R$ = function (LgVal, SmVal) {
	let DeviceMode = screen.availWidth <= 500 || screen.availHeight <= 700 ? "Small" : "Large";
	if (DeviceMode == "Large") {
		return LgVal;
	} else if (DeviceMode == "Small") {
		return SmVal;
	}
}

prjx447 = {};
prjx447.dbug = [];
prjx447.ApiPath = "https://vps124183.inmotionhosting.com/prjx447";

prjx447.GetFileById = function (ThisId) {
	return new Promise((Res, Rej) => {
		let FncD = {};
		FncD.Id = "gid://shopify/MediaImage/" + ThisId;
		FncD.ShopName = "wildfedhorse.myshopify.com";
		FncD.AccessToken = "baf79b00f450bc7daa9da8f42519328d";
		FncD.Query = `
		query getFile($id: ID!) {
			node(id: $id) {
				... on MediaImage {
					image {
						url
					}
				}
			}
		}`;
		FncD.Url = `https://${FncD.ShopName}/api/2024-04/graphql.json`;
		FncD.Headers = { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": FncD.AccessToken }
		FncD.Body = { query: FncD.Query, variables: { id: FncD.Id } };
		fetch(FncD.Url, {
			method: "post",
			headers: FncD.Headers,
			body: JSON.stringify(FncD.Body)
		})
			.then(Res => {
				return Res.json();
			})
			.then(ThisReturn => {
				Res(ThisReturn);
			})
			.catch(Err => {
				Rej(Err);
			});
	});
}

prjx447.GetProductByHandle = function (ThisHandle) {
	return new Promise((Res, Rej) => {
		let FncD = {};
		FncD.Handle = ThisHandle;
		FncD.ShopName = "wildfedhorse.myshopify.com";
		FncD.AccessToken = "baf79b00f450bc7daa9da8f42519328d";
		FncD.Query = `
		query getProduct($handle: String!) {
			product(handle: $handle) {
				title
				descriptionHtml
				featuredImage { url }
				variants(first: 1) {
					edges { node { price { amount currencyCode } } }
				}
				rating: metafield(namespace: "reviews", key: "rating") {
					value
				}
				reviewCount: metafield(namespace: "reviews", key: "rating_count") {
					value
				}
				badge: metafield(namespace: "judgeme", key: "badge") {
					value
				}
			}
		}`;
		FncD.Url = `https://${FncD.ShopName}/api/2024-04/graphql.json`;
		FncD.Headers = { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": FncD.AccessToken }
		FncD.Body = { query: FncD.Query, variables: { handle: ThisHandle } };
		fetch(FncD.Url, {
			method: "post",
			headers: FncD.Headers,
			body: JSON.stringify(FncD.Body)
		})
			.then(Res => {
				return Res.json();
			})
			.then(ThisReturn => {
				try {
					ThisReturn = ThisReturn.data.product;
					ThisReturn.reviewCount.value = parseFloat(ThisReturn.reviewCount.value);
					ThisReturn.rating.value = JSON.parse(ThisReturn.rating.value);
					ThisReturn.variants.edges.forEach((Edge) => {
						Edge.node.price.amount = parseFloat(Edge.node.price.amount);
					});
					ThisReturn.Handle = FncD.Handle;
				} catch (e) {
					console.log("GetProductByHandle Error", e);
				}
				Res(ThisReturn);
			})
			.catch(Err => {
				Rej(Err);
			});
	});
}

prjx447.GetProductsByHandles = function (Handles) {
	return new Promise((Res, Rej) => {
		let FncD = {};
		FncD.Returns = []
		Handles.forEach((Handle) => {
			prjx447.GetProductByHandle(Handle)
				.then(ThisReturn => {
					FncD.Returns.push(ThisReturn);
					if (FncD.Returns.length == Handles.length) {
						Res(FncD.Returns);
					}
				})
				.catch(Err => {
					console.log("Err", Err);
				});
		});
	})
}

prjx447.DbToHtml = function (ThisTxt) {
	if (typeof ThisTxt != "string") return ThisTxt;
	try {
		return ThisTxt
			.replace(/[\r\n]/g, "<br>")
			.replace(/  /g, "&nbsp;&nbsp;")
			.replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;");
	} catch (e) {
		console.log(e);
		return ThisTxt;
	}
}

prjx447.HomePageHeader = function (ThisLmnt) {
	let FncD = {};
	FncD.BannerContent = $(ThisLmnt)
		.find(".banner__content")
		.css({ width: "100%", textAlign: "center" })[0];
	FncD.BannerBox = $(ThisLmnt)
		.find(".banner__box")
		.css({ fontFamily: "Lato", fontSize: 16, lineHeight: "1em", color: "#fff", backgroundColor: "rgba(255,255,255,0)", margin: 0, width: "100%", maxWidth: "unset", marginTop: R$("", "-10em"), padding: R$("", 0) })[0];
	FncD.TextRows = $(ThisLmnt)
		.find(".animate__step-container")
		.css({ marginBottom: R$(75, 69) })[0];
	FncD.DeviceSize = R$("Large", "Small");
	$(FncD.TextRows).empty();
	if (FncD.DeviceSize == "Large") {
		FncD.Rows = [
			{
				Files: [
					{ Key: "Row1", Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/HomePagePhrasing-WholeFoodNutrition.svg?v=1781364396", Css: {} }
				]
			},
			{
				Files: [
					{ Key: "Row2", Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/HomePagePhrasing-InspiredByNatureGuidedByScience.svg?v=1781365224", Css: {} }
				]
			}
		]
	} else if (FncD.DeviceSize == "Small") {
		FncD.Rows = [
			{
				Files: [
					{ Key: "Row1", Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/HomePagePhrasing-WholeFoodNutrition.svg?v=1781364396", Css: {} } //https://cdn.shopify.com/s/files/1/0115/0202/6809/files/HomePagePhrasing-WholeFoodNutrition-Mobile.svg?v=1781369445
				]
			},
			{
				Files: [
					{ Key: "Row2", Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/HomePagePhrasing-InspiredByNatureGuidedByScience-Mobile.svg?v=1781369445", Css: { width: "60%", marginTop: "-.5em" } }
				]
			}
		]
	}
	FncD.Rows.forEach((RowD, RowCreep) => {
		RowD.Div = $("<div>")
			.attr({ class: "Row Row" + RowCreep })
			.css({ textAlign: "center", display: "flex", placeContent: "center" })
			.appendTo(FncD.TextRows)[0];
		RowD.Files.forEach((FileD, FileCreep) => {
			$("<img>")
				.attr({ class: "Svg Svg" + FileCreep + " " + FileD.Key, src: FileD.Url })
				.css({ opacity: 0, width: R$("90%", "97%"), filter: "drop-shadow(5px 5px 10px rgba(0,0,0,.5))" })
				.css(FileD.Css)
				.on({
					load: e => {
						$(e.currentTarget).animate({ opacity: 1 });
					}
				})
				.appendTo(RowD.Div)[0];
		});
	});
	if (R$(1, 2) == 2) {
		$(FncD.TextRows).find(".Svg1").css({ marginTop: -5 });
	}
}

prjx447.DiscoverTheWildFedDifference = function (ThisLmnt) {
	$(ThisLmnt).find("h2.heading-block").css({ fontSize: R$("3.7em", "2.3em"), marginTop: R$("", "-1.1em"), marginBottom: R$("", "0.5em") });
	$(ThisLmnt).find("div.text-block").css({ fontSize: R$("1.5em", "") });
}

prjx447.HomePageIconList = function (ThisLmnt) {
	let FncD = {};
	if (location.pathname != "/") return;
	FncD.Mode = R$("Large", "Small");
	if (FncD.Mode == "Large" || FncD.Mode == "Small") {
		$(ThisLmnt).find("ul.icon-list__list").css({ display: "flex", flexWrap: "wrap", gap: 60, justifyContent: "center" });
		$(ThisLmnt).find("ul.icon-list__list li").css({ display: "flex", flexDirection: "column", gap: 10, alignContent: "center", alignItems: "center" });
		$(ThisLmnt).find("ul.icon-list__list li h3")
			.css({ fontFamily: "Lato" })
			.each((Creep, ThisH3) => {
				ThisH3.HtmlPrep = ThisH3.innerHTML.trim().split(" ");
				ThisH3.HtmlPrep.forEach((HtmlRow, HtmlCreep) => {
					ThisH3.HtmlPrep[HtmlCreep] = `<div class='Words Word${HtmlCreep}'>${HtmlRow}</div>`;
				});
				$(ThisH3)
					.css({ textAlign: "center" })
					.html(ThisH3.HtmlPrep.join(""));
				$(ThisH3).find(".Word0").css({ fontSize: ".8em" });
				$(ThisH3).find(".Words").not(".Word0").css({ fontSize: ".9em", fontWeight: 900 });
			});
		$(ThisLmnt).find("ul.icon-list__list svg").css({ width: 60 }).prop({ StartRot: 0 });
	} else {
		$(ThisLmnt).find(".color--bg-tertiary").css({ padding: "0 0" });
		$(ThisLmnt).find("ul.icon-list__list").css({ display: "flex", gap: 8, flexDirection: "column", marginLeft: "8%" });
		$(ThisLmnt).find("ul.icon-list__list li").css({ display: "flex", alignItems: "center" });
		$(ThisLmnt).find("ul.icon-list__list svg").css({ width: 35 }).prop({ StartRot: 0 });
	}
	FncD.SvgCreep = -1;
	FncD.Rotator = function () {
		ThisD = {};
		ThisD.Svgs = $(ThisLmnt).find("ul.icon-list__list svg");
		FncD.SvgCreep++;
		if (FncD.SvgCreep >= ThisD.Svgs.length) FncD.SvgCreep = 0;
		ThisD.Svg = ThisD.Svgs[FncD.SvgCreep];
		// if (ThisD.Svg.StartRot == 0 || ThisD.Svg.StartRot == 360) {
		// 	ThisD.Svg.StartRot = 0;
		// 	ThisD.Svg.EndRot = 180;
		// } else if (ThisD.Svg.StartRot == 180) {
		// 	ThisD.Svg.EndRot = 360;
		// }
		$({ Rot: 0 }).animate({ Rot: 90 }, {
			duration: 450,
			step: function (ThisRot, Fx) {
				$(ThisD.Svg).css({ rotate: `y ${ThisRot}deg` });
			},
			complete: function () {
				// ThisD.Svg.StartRot = ThisD.Svg.EndRot;
				// setTimeout(() => {
				// 	FncD.Rotator();
				// }, 1000);
				$({ Rot: 90 }).animate({ Rot: 0 }, {
					duration: 450,
					step: function (ThisRot, Fx) {
						$(ThisD.Svg).css({ rotate: `y ${ThisRot}deg` });
					},
					complete: function () {
						ThisD.Svg.StartRot = ThisD.Svg.EndRot;
						setTimeout(() => {
							FncD.Rotator();
						}, 1000);
					}
				})
			}
		})
	}
	FncD.Rotator();
}

prjx447.UpdateHomePageIntro = function (ThisLmnt) {
	let FncD = {};
	FncD.HeadingBlock = $(ThisLmnt).find("h2.heading-block")[0];
	$(FncD.HeadingBlock).css({ margin: R$("auto 10em", ""), fontSize: R$("1.4em", "1.15em") });
}

prjx447.HorseFeedProducts = function (ThisLmnt) {
	let FncD = {};
	FncD.TgtParent = $(ThisLmnt).find("div")[0];
	$(FncD.TgtParent).css({ display: "flex", flexDirection: R$("row", "column"), justifyContent: "center", alignContent: "space-between", gap: R$(100, 40), padding: "25px 0" });
	FncD.Handles = ["wild-fed-horse-feed", "1-lb-sample-bag-wild-fed-horse-feed"];
	FncD.Handles.forEach((Handle) => {
		$("<div>")
			.attr({ class: "Product " + Handle })
			.css({ display: "block", textAlign: "center" })
			.appendTo(FncD.TgtParent)[0]
	});
	prjx447.GetProductsByHandles(FncD.Handles)
		.then(ThisReturn => {
			FncD.Products = ThisReturn;
			FncD.Products.forEach((ProductD) => {
				let TgtLmnt;
				TgtLmnt = $(FncD.TgtParent).find(".Product." + ProductD.Handle)[0];
				TgtLmnt.Link = $("<a>")
					.attr({ class: "Link", href: "/products/" + ProductD.Handle })
					.prop({ Data: ProductD })
					.css({ textDecoration: "none", display: "table", margin: "auto", textAlign: "center" })
					.on({
						click: e => {
							Shopify.analytics.publish("prjx447Event", {
								InteractionType: "Click",
								InteractionName: "ProductClick: " + e.currentTarget.Data.Handle,
								SectionId: "Feed Page Product List",
								CustomData: {}
							});
						}
					})
					.appendTo(TgtLmnt)[0];
				TgtLmnt.Img = $("<img>")
					.attr({ class: "prjx447Img", src: ProductD.featuredImage.url })
					.css({ opacity: 0, width: R$("auto", "50%"), height: R$(window.innerHeight * .40, "auto"), display: "table", margin: "auto" })
					.on({
						load: e => {
							$(e.currentTarget).animate({ opacity: 1 });
							$(FncD.Ingredients).animate({ opacity: 1 });
						}
					})
					.appendTo(TgtLmnt.Link)[0];
				TgtLmnt.Title = $("<h3>")
					.attr({ class: "prjx447Title product-card__title type--heading copy--large" })
					.css({ width: R$("auto", "50%"), display: "table", margin: "auto" })
					.html(ProductD.title)
					.appendTo(TgtLmnt.Link)[0];
				TgtLmnt.Reviews = $("<a>")
					.attr({ class: "Reviews", href: "/products/" + ProductD.Handle + "#judgeme_product_reviews" })
					.css({ width: R$("auto", "50%"), display: "table", margin: "auto", textDecoration: "none" })
					.appendTo(TgtLmnt)[0];
				if (ProductD.reviewCount.value >= 5) {
					TgtLmnt.ReviewStars = $("<div>")
						.attr({ class: "prjx447ReviewStars" })
						.css({ display: "inline-block" })
						.html(ProductD.badge.value)
						.appendTo(TgtLmnt.Reviews)[0];
					$(".jdgm-star").css({ color: "rgb(98, 139, 55)", margin: "0px 5px" });
					$(".jdgm-prev-badge__text").css({ display: "none" });
					TgtLmnt.ReviewCount = $("<div>")
						.attr({ class: "prjx447ReviewCount product-card__reviews-count copy--small" })
						.css({ display: "inline-block", marginLeft: 15 })
						.html(ProductD.reviewCount.value + " Reviews")
						.appendTo(TgtLmnt.Reviews)[0];
				}
				TgtLmnt.Price = $("<div>")
					.attr({ class: "prjx447Price product-card__price-badge space--mt--xsmall" })
					.css({ marginTop: 0, width: R$("auto", "50%"), display: "table", margin: "auto" })
					.appendTo(TgtLmnt)[0]
				if (ProductD.variants.edges[0].node.price.amount > 0) {
					let Fmt;
					Fmt = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
					$(TgtLmnt.Price).html(Fmt.format(ProductD.variants.edges[0].node.price.amount));
				} else {
					let Html;
					Html = "Check with a <a href='https://wildfedhorse.com/pages/find-feed-dealer-page'>local dealer</a> for pricing in your area";
					$(TgtLmnt.Price).html(Html);
				}
			});
		})
		.catch(Err => {
			console.log("Err", Err);
		});
}

prjx447.TabsInFeedPage = function (ThisLmnt) {
	let FncD = {};
	FncD.TgtParent = $(ThisLmnt).find("div")[0];
	$(FncD.TgtParent).css({ padding: R$(25, 5) });
	FncD.TabMap = [
		{
			TabLabel: "Nutrition Profile",
			Header: "Nutrition Profile",
			Content: {
				Ingredients: prjx447.FeedIngredients,
				NutritionProfile: prjx447.FeedNutrientProfile
			},
			Fnc: function (ThisD) {
				ThisD.ContentStage = $("<div>")
					.attr({ class: "prjx447 ContentStage" })
					.css({ display: "flex", flexDirection: R$("row", "column"), justifyContent: "center", alignContent: "center", gap: R$(100, 20), marginTop: 20 })
					.appendTo(ThisD.Stage)[0];
				for (let TableKey in ThisD.Content) {
					let ThisLmnt;

					if (TableKey == "Ingredients") {
						ThisLmnt = $("<div>")
							.attr({ class: TableKey })
							.css({ flex: 1, display: "inline-block", fontFamily: "inherit", fontSize: "inherit", textAlign: "left" })
							.html(prjx447.FeedIngredientsHtml)
							.appendTo(ThisD.ContentStage)[0];
						ThisLmnt.Header = $(ThisLmnt).find("strong")[0];
						ThisLmnt.Header.innerHTML = ThisLmnt.Header.innerHTML.replace("Ingredients:", "Ingredients")
						$(ThisLmnt.Header.parentNode).css({ fontSize: "1.3em", textAlign: "center", textTransform: "uppercase", marginBottom: 20 });
						ThisLmnt.OurPromise = $(ThisLmnt).find("strong")[1];
						$(ThisLmnt.OurPromise.parentNode).css({ marginTop: 10 })
						ThisLmnt.Img = $("<img>")
							.attr({ class: "Pellets", src: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Pellets.png?v=1776876757" })
							.css({})
							.appendTo(ThisLmnt)[0]

					} else if (TableKey == "NutritionProfile") {
						let ThisLmnt = $("<div>")
							.attr({ class: "NutrientStage" })
							.css({ flex: 1, textAlign: "center" })
							.appendTo(ThisD.ContentStage)[0];
						ThisLmnt.Header = $("<div>")
							.attr({ class: "Header" })
							.css({ fontSize: "1.3em", textTransform: "uppercase", fontWeight: 900, marginBottom: 20 })
							.html("Guaranteed Analysis")
							.appendTo(ThisLmnt)[0];
						ThisLmnt.Table = $("<table>")
							.attr({ class: TableKey })
							.css({ fontFamily: "inherit", fontSize: "inherit", borderCollapse: "collapse", width: "100%", textAlign: "center" })
							.appendTo(ThisLmnt)[0];
						ThisD.Content[TableKey].forEach((ContentD, ContentCreep) => {
							let ThisTr = $("<tr>")
								.attr({ class: "Row" + ContentCreep })
								.prop({ Data: ContentD })
								.appendTo(ThisLmnt.Table)[0];
							for (let ThisField in ContentD) {
								let ThisTd = $("<td>")
									.attr({ class: ThisField })
									.prop({ Data: ContentD, Field: ThisField })
									.css({ padding: 8, border: "1px solid #aaa" })
									.html(ContentD[ThisField])
									.appendTo(ThisTr)[0];
							}
						});
						$(ThisLmnt).find("tr.Row0").css({ fontWeight: 900 });
					}
				}
			}
		},
		{
			TabLabel: "The Wild Fed Difference",
			Header: "What Makes Our Feed Different?",
			Content: [
				{
					Header: "No Corn", Id: 29531872919752, File: "1_a341f901-2a68-492b-bac3-c80536f3dc47",
					Content: "Corn is commonly used in many feeds but is high in omega-6 fatty acids, which can promote inflammation when not balanced. It can also contribute to a more acidic stomach environment, which may negatively impact digestive health."
				},
				{
					Header: "No Soy", Id: 29534514577608, File: "wild_fed_is_7_cc2f2efd-a314-4601-8115-1788a07657ff",
					Content: "Soy is not safe to eat raw for horses or humans and is not a food horses would naturally consume. Even when processed, soy contains compounds like phytoestrogens that can influence hormone balance, along with residual anti-nutrients that may affect gut health and mineral absorption."
				},
				{
					Header: "No Sweetners", Id: 29531872854216, File: "3_eb080ec0-36ea-4786-afc9-09af7780d89d",
					Content: "We never use refined sugars or sweeteners like molasses, which can disrupt metabolic balance. Our feed is naturally palatable without the need for added sweeteners."
				},
				{
					Header: "No Industry By-products", Id: 29531872952520, File: "5_c22da691-64aa-4ad3-b678-d13e0dd7bb7e",
					Content: "Common by-products like soybean meal, peanut hulls, beet pulp, and rice bran are added to many feeds to cut costs, but they lack nutritional value and can be inflammatory. "
				},
				{
					Header: "No Flax", Id: 29531872821448, File: "4_598c0f11-b448-428e-b5ae-fe33e9f3de31",
					Content: "While flax is often used in feeds for its omega-3s, it can go rancid quickly and contribute to oxidative stress. Instead, we use chia seeds—a stable, nutrient-rich alternative that provides anti-inflammatory benefits and supports digestion."
				},
				{
					Header: "No Fillers", Id: 29531872985288, File: "6_ebe495d9-bf65-4d18-b2ac-cbb4d3ef6acd",
					Content: "Unlike traditional horse feeds that use cheap fillers and isolated synthetic vitamins and minerals, our feed is designed with your horse's health in mind. <b>No soybean hulls, no peanut hulls, no rice bran</b> — just pure, natural ingredients that support your horse's digestive and overall health."
				},
			],
			Fnc: function (ThisD) {
				ThisD.ContentStage = $("<div>")
					.attr({ class: "prjx447 ContentStage" })
					.css({ display: "table", width: R$("50%", ""), margin: "auto", textAlign: "left" })
					.appendTo(ThisD.Stage)[0];
				ThisD.Content.forEach((ContentD, ContentCreep) => {
					ContentD.StageRow = $("<div>")
						.attr({ class: "StageRow" })
						.css(R$(
							{ display: "flex", flexDirection: "row", alignItems: "flex-start", textAlign: "left", margin: "18px auto 0" },
							{ margin: 28 }
						))
						.appendTo(ThisD.ContentStage)[0];
					prjx447.GetFileById(ContentD.Id)
						.then(ThisReturn => {
							ContentD.ImgSrc = ThisReturn.data.node.image.url;
							ContentD.ColumnImg = $("<img>")
								.attr({ class: "ColumnImg", src: ContentD.ImgSrc })
								.css(R$(
									{ width: 95, height: 95 },
									{ width: 120, height: 120, float: "left", shapeOutside: "circle(35%)", borderRadius: "50%", marginLeft: -15, marginBottom: 5 }
								))
								.appendTo(ContentD.StageRow)[0];
							ContentD.Text = $("<div>")
								.attr({ class: "Text" })
								.css({ marginTop: 5 })
								.appendTo(ContentD.StageRow)[0];
							ContentD.ColumnHeader = $("<div>")
								.attr({ class: "ColumnHeader" })// type--heading title--small
								.css({ display: "block", fontSize: "1.1em", fontWeight: 900, marginBottom: R$(-3, 0) })
								.html(ContentD.Header)
								.appendTo(ContentD.Text)[0];
							ContentD.ColumnContent = $("<div>")
								.attr({ class: "ColumnContent" })
								// .css({ display: "inline-block", textAlign: "left" })
								.html(ContentD.Content)
								.appendTo(ContentD.Text)[0];

						})
						.catch(Err => {
							console.log("Err", Err);
						});
				});
				$(".prjx447.StageColumns").animate({ scrollLeft: -1000 });
			}
		},
		{
			TabLabel: "Feeding Guidelines",
			Header: "Feeding Instructions",
			Content: [
				{
					Question: "IF YOUR HORSE HAS DAMAGED/WORN TEETH & CAN NO LONGER EAT HAY",
					Answer: "• Wild Fed horse feed can be fed as the sole feed for your horse and no additional supplementation is necessary as it is a nutrient dense feed and provides your horse with all the nutrients it needs.<br> • When Wild Fed is the only feed to be given to your 1,000 lb horse, start with approx. 7-8 lbs of feed 2X/day.<br> • If your horse is not gaining enough weight with this amount then add more.<br> • Do not feed more than 10 lbs feed per meal.<br> • If your horse is gaining too much weight from this amount then reduce feed.<br> • Allow 3-4 hours between meals if feeding more than 4-5 lbs of feed at a time.<br> • The amount of feed your horse requires depends on his/her activity level and breed."
				},
				{
					Question: "IF YOUR HORSE CAN STILL EAT HAY & YOU ARE USING THIS FEED TO ADD WEIGHT TO YOUR HORSE",
					Answer: "• Provide your horse with good quality hay and/or pasture, free choice salt and clean water. <br> • Start with 2-4 lb Wild Fed feed per day and increase as needed. <br> • It could take 2-4 weeks before you notice results. <br> • Wild Fed is a nutrient dense feed but additional. supplementation may still be required if it is fed in smaller quantities."
				},
				{
					Question: "WILD FED FOR ATHLETIC PERFORMANCE",
					Answer: "• Wild Fed's high calorie content is perfect for the demands of a performance horse."
				},
				{
					Question: "IF YOU ARE USING THIS FEED AS A TREAT",
					Answer: "• Give a cup of feed as a treat to your horse just cause you love them. <br> • Give 2-4 cups after a long ride to provide extra calories. <br> • If you are giving your horse other herbs or special. supplements use this feed as a base to mix in your herbs so the horse will eat them."
				},
				{
					Question: "IF YOUR HORSE IS ALREADY OVERWEIGHT",
					Answer: "• This is a nutrient dense food and will be an added benefit to any horse's diet but for an overweight horse, only give a small handful as a treat or a base to add in additional herbs or supplements."
				},
				{
					Question: "IF YOU TRAVEL WITH YOUR HORSE",
					Answer: "• This is a great alternative to hay bales as it is more compact. <br> • Bring Wild Fed feed with you on camping trips, long trailer rides or anyplace where hay is inconvenient. <br> • 1 bag of horse feed is approximately equivalent to 1 bale of hay."
				},
			],
			Fnc: function (ThisD) {
				ThisD.ContentStage = $("<div>")
					.attr({ class: "prjx447 ContentStage" })
					.css({ display: "table", width: R$("50%", ""), margin: "auto", textAlign: "left" })
					.appendTo(ThisD.Stage)[0];
				ThisD.Content.forEach((ContentD, ContentCreep) => {
					let Lmnts = {};
					Lmnts.Row = $("<div>")
						.attr({ class: "Row Row" + ContentCreep })
						.css({ marginTop: 20, margin: "20px auto 0", textAlign: "left" })
						.appendTo(ThisD.ContentStage)[0];
					Lmnts.Question = $("<h3>")
						.attr({ class: "Question Question" + ContentCreep + " copy--large line-height--copy" })
						.prop({ Data: ContentD, Viewing: false, Index: ContentCreep, TabStage: FncD.TabStage })
						.css({ display: "table" })
						.html(ContentD.Question)
						.on({
							click: e => {
								return;
								let ThisQuestion, MaxWidth = 0;
								ThisQuestion = e.currentTarget;
								$(ThisQuestion.TabStage).find(".Question").each((Creep, ThisLmnt) => {
									MaxWidth = Math.max(MaxWidth, ThisLmnt.clientWidth)
								});
								ThisQuestion.Viewing = !ThisQuestion.Viewing;
								if (ThisQuestion.Viewing) {
									$(ThisQuestion.Answer).css({ display: "table", margin: "0 auto", width: MaxWidth }).animate({ opacity: 1 });
									$(ThisQuestion.Answer).find("iframe").css({ width: MaxWidth, height: MaxWidth * (9 / 16), border: "none" })
								} else {
									$(ThisQuestion.Answer).css({ display: "none", opacity: 0 });
								}
							}
						})
						.appendTo(Lmnts.Row)[0];
					Lmnts.Answer = $("<div>")
						.attr({ class: "Answer Answer" + ContentCreep, Index: ContentCreep })
						.css({ textAlign: "left", marginLeft: "1em" })
						.html(ContentD.Answer)
						.appendTo(Lmnts.Row)[0];
					Lmnts.Question.Answer = Lmnts.Answer;
					Lmnts.Answer.Question = Lmnts.Question;
				});

				$(ThisD.Stage).find("iframe")
					.css({ width: "100%" })
					.each((IframeCreep, ThisIframe) => {
						$(ThisIframe).css({ height: ThisIframe.clientWidth * (9 / 16) })
					});
			}
		},
		{
			TabLabel: "Hydration & Soaking",
			Header: "Do the Pellets Have to Be Soaked?",
			Content: `<div class="Question">We recommend adding water to every feeding for optimal hydration and safety.</div>
						<div class="Indent0">Our pellets are made without binders and formed under high pressure, creating a naturally dry, concentrated feed. Adding water helps soften the pellets, making them easier to chew, safer to swallow, and more supportive of healthy digestion.</div>
						<div class="Question">The good news—this doesn't have to be complicated.</div>
						<div class="Indent1">
							<p>• A simple splash of water is enough</p>
							<p>• Swish and feed right away—no need to wait</p>
							<p>• Even a scoop from your horse's trough works perfectly</p>
						 	<p style="font-weight:600;">Many horses actually enjoy a slightly crunchy texture, so full soaking isn't necessary for most.</p>
						</div>
						<div class="Question">When to fully soak?</div>
						<div class="Indent1">• Older horses, dental issues, or reduced saliva production may benefit from fully softened pellets.</div>
						<div class="Question">Why Wet Your Hay Pellets?</div>
						<div class="Indent1">
							<p><b>• Supports hydration</b> - Adds extra moisture to your horse's diet—especially helpful in dry climates or for horses that don't drink enough.</p>
							<p><b>• Reduces risk of choke</b> - Lightly moistening pellets softens them, making them easier to chew and swallow safely.</p>
							<p><b>• Improves digestion</b> - Hydrated feed is gentler on the gut and supports smoother breakdown and nutrient absorption.</p>
							<p><b>• Mimics natural forage moisture</b> - Fresh pasture naturally contains water—wetting pellets brings feed closer to how horses are designed to eat.</p>
							<p><b>• Quick & simple (no soaking required)</b> - Just add a splash of water, swish, and feed immediately—no need to wait for full expansion.</p>
							<p><b>• Flexible for your setup</b> - Even a quick scoop of water from your horse's trough works perfectly—no extra setup needed.</p>
						</div>
						<div class="Iframes">
						<iframe src='https://www.youtube.com/embed/MzBwjmFVn_c?autoplay=1&mute=1&loop=1&playlist=MzBwjmFVn_c&enablejsapi=1' frameborder=0 	allow='autoplay; encrypted-media'></iframe>
						<iframe src='https://www.youtube.com/embed/f_388H74yZE?autoplay=1&mute=1&loop=1&playlist=f_388H74yZE&enablejsapi=1' frameborder=0 allow='autoplay; encrypted-media'></iframe>
						</div>
						`,
			Fnc: function (ThisD) {
				let ThisHeader, ThisStage;
				// ThisHeader = $(".TabStageHeader").css({ display: "table", margin: "auto" })[0];
				ThisD.ContentStage = $("<div>")
					.attr({ class: "prjx447 ContentStage" })
					.css({ display: "table", width: R$("50%", ""), margin: "15px auto 0", textAlign: "left" })
					.html(ThisD.Content)
					.appendTo(ThisD.Stage)[0];
				// ThisStage = $("<div>")
				// 	.attr({ class: "Stage" })
				// 	.css({  width: "auto", margin: "20px auto 0px", textAlign: "center", width: ThisHeader.clientWidth, textAlign: "left" })
				// 	.html(ThisD.Content)
				// 	.appendTo(ThisD.Stage)[0];
				$(ThisD.ContentStage).find(".Question")
					.css({ fontSize: "1.1em", fontWeight: 900, marginTop: "1em" });
				$(ThisD.ContentStage).find(".Indent1")
					.css({ marginLeft: 15 });
				$(ThisD.ContentStage).find("p").css({ margin: "5px 0" })
				$(ThisD.ContentStage).find(".Iframes")
					.css({ display: "flex", flexDirection: R$("row", "column"), gap: 10 })
				$(ThisD.ContentStage).find("iframe")
					.css({ flex: 1, margin: "auto", width: "100%", borderRadius: 10, marginTop: 15 })
					.each((Creep, ThisIframe) => {
						$(ThisIframe).css({ height: ThisIframe.clientWidth * (9 / 16) });
					})
			}
		},
		{
			TabLabel: "Common Questions",
			Header: "Frequently Asked Questions",
			Content: [
				{
					Question: "WHY DO WE INCLUDE OATS IN OUR FEED?",
					Answer: `We include a small amount of oats (3.5%) as a <b>clean, whole-food source of phosphorus</b> — an essential mineral for structural integrity, energy metabolism, and overall balance.<br><br>
						Rather than relying on synthetic inputs, we formulate with <b>nutrients sourced from real ingredients</b>. Oats naturally provide phosphorus in a form the body recognizes and utilizes with ease.<br><br>
						What about sugar and starch?<br><br>
						Oats are included with precision and restraint:<br> • Just 3.5% of the formula<br> • Total NSC remains low at 9.5-10%<br> • Formulated to be safe for metabolic horses<br>This ensures nutrient density without compromising metabolic health.<br><br>
						<b>Rooted in nature.</b> In natural environments, horses instinctively consume <b>seasonal seed heads</b>, which are rich in energy and minerals. Our inclusion of oats reflects this pattern — <b>intentional, minimal, and biologically aligned</b>.<br><br>
						<b>Purposeful, not excessive.</b>  Oats are not used as a filler or primary energy source, but as a <b>targeted, whole-food mineral contribution</b> — supporting balance, integrity, and a truly thoughtful formulation.<br><br><iframe src='https://www.youtube.com/embed/eTy5KlqX12g?autoplay=1&mute=1&loop=1&playlist=eTy5KlqX12g&enablejsapi=1' frameborder=0 allow='autoplay; encrypted-media'></iframe>` },//
				{
					Question: "CAN I FEED WILD FED HORSE FEED TO MY HORSE WHO HAS METABOLIC ISSUES?",
					Answer: "We have many customers who feed Wild Fed Horse Feed to their horses with Cushing's disease and Insulin Resistance. In fact, my own horse Shadow showed signs of Cushing's before I started feeding him Wild Fed and his symptoms have since gone away. For horses with Cushing's the recommendation is to keep the feed under 16% NSC at the highest (preferably under 15%). Horses with acute laminitis require an NSC of less than 10%. Our feed has been averaging at 14.2% NSC but has gotten as low as 13.1%."
				},
				{
					Question: "WILL THIS FEED MAKE MY HORSE “HOT?”",
					Answer: "It has not been our experience that this feed makes a horse “hot”. For the majority of horses, this will not be an issue. I cannot say that every horse will respond the same way. There are, of course, very sensitive horses that might become overly energized but this would be the exception and not the rule.<br><br>There are two ingredients in the feed that cause concern for those with high energy or sensitive horses: oats and the alfalfa. I will address both of these ingredients.<br><br>Oats only make up about 4% of the feed. They are rich in phosphorus, an important mineral, that is low in grass hays and alfalfa which is why we chose to include it in our feed. Oats have high energy content because of the sugars it contains. This relatively small amount of oats in the feed, will not make your horse hot because it contributes minimally to the high energy content of the feed. Our feed is still considered a low sugar feed even with the small amount of oats it contains.<br><br>Alfalfa makes up about 25% of the feed. It is a highly nutritious herb and contributes greatly to the mineral content as well as the protein content of the feed. Alfalfa is often higher in energy content than grass hays but this energy content comes from protein and fiber and not sugars. The higher energy content in the alfalfa could result in greater weight gain but should not make your horse “hot” like a cereal grain might. Herbalist regard alfalfa to be a highly medicinal plant because it is so nutrient dense and is often found in pregnancy teas for that reason. That being said, when given as a sole feed or in high quantities, it can be difficult on the kidneys because of its high protein and mineral content. So it is optimally fed at amounts <30% of the ration."
				},
				{
					Question: "IS IT SAFE FOR MY HORSE TO CONSUME RED CLOVER?",
					Answer: "RED CLOVER Trifolium pretense<br><br>Red clover is a common herb found in pastures all over the world. It is a legume high in protein, phytoestrogens and nutrients. Red clover eaten in large quantities causes photosensitivity and excessive salivation in humans and animals. In both cases it is due to different types of mold that grow on the clover not the clover itself. Clover is used as a cover crop and when it is harvested it is often fed to cattle like one would feed grass hay. Clover like hay is susceptible to mold when not dried properly.<br><br>We do not use agricultural red clover we use human grade organic clover which has been laboratory tested by a 3rd party to look for mold and other toxins and contaminates.<br><br>In cases of horses reacting to the clover, the clover was being consumed at ~20% of the total ration and they were eating clover out of the pasture or in the hay. Red clover is a very small percentage of our feed <1% and thus it is not capable of causing these symptoms in these amounts."
				},
			],
			Fnc: function (ThisD) {//Use the Fnc from TabLable "Feeding Guidelines"
				ThisD.TabMap.forEach((ThisMap) => {
					if (ThisMap.TabLabel == "Feeding Guidelines") {
						ThisMap.Fnc(ThisD);
					}
				})
			}
		},
	];
	FncD.TabBar = $("<div>")
		.attr({ class: "TabBar" })
		.css({ display: "flex", flexDirection: "row", justifyContent: "center", gap: 0, boxSizing: "border-box", padding: "0 1px", width: "100%", })
		.appendTo(FncD.TgtParent)[0];
	FncD.HashMatch = 0
	FncD.TabMap.forEach((MapD, MapCreep) => {
		if (location.hash.substr(1).toLowerCase() == MapD.TabLabel.toLowerCase().replace(/ /g, "-")) {
			FncD.HashMatch = MapCreep;
		}
		MapD.TabMap = FncD.TabMap;
		MapD.Tab = $("<div>")
			.attr({ class: "TabLabel TabLabel" + MapCreep + " type--heading copy--small" })
			.prop({ Data: MapD })
			.css({ minWidth: 0, fontSize: R$("", ".65em"), fontWeight: R$(100, 900), padding: R$("10px 20px", "10px 3px"), boxSizing: "border-box", textAlign: "center", justifyContent: "center", display: "flex", alignItems: "center", borderTopLeftRadius: 8, border: "1px solid #ccc", borderTopRightRadius: 8, cursor: "pointer" })
			.html(MapD.TabLabel)
			.on({
				click: e => {
					let ThisTab = e.currentTarget;
					$(FncD.TgtParent).find(".TabLabel").css({ color: "rgb(95, 75, 58)", backgroundColor: "#fff" });
					$(ThisTab).css({ color: "#fff", backgroundColor: "rgb(98, 139, 55)" });
					$(FncD.TabStage).empty().css({ opacity: 0 });
					ThisTab.Data.Stage = FncD.TabStage;
					ThisTab.TabStageHeader = $("<h2>")
						.attr({ class: "TabStageHeader type--heading title--medium align--text-center" })
						.css({ textTransform: "uppercase" })
						.html(ThisTab.Data.Header)
						.appendTo(FncD.TabStage)[0];
					ThisTab.Data.Fnc(ThisTab.Data);
					$(FncD.TabStage).animate({ opacity: 1 });
					Shopify.analytics.publish("prjx447Event", {
						InteractionType: "Click (" + (e.originalEvent.isTrusted ? "By User" : "By Default") + ")",
						InteractionName: "Tab: " + e.currentTarget.Data.TabLabel,
						SectionId: "Feed Page Dynamic Tab UI",
						CustomData: {}
					});
				}
			})
			.appendTo(FncD.TabBar)[0];
	});
	FncD.TabStage = $("<div>")
		.attr({ class: "TabStage" })
		.css({ borderTop: "1px solid #ccc", marginTop: -1, boxSizing: "border-box", padding: 15 })//, height: window.innerHeight * .5, overflowY: "scroll"
		.appendTo(FncD.TgtParent)[0];
	console.log("FncD.HashMatch", FncD.HashMatch);
	$(FncD.TabBar).find(".TabLabel" + FncD.HashMatch)[0].click();
}

prjx447.Video = function () { }//YtId, BgColor, FlexDx (Video/Text Orientation), 

prjx447.Video.Create = function (ThisLmnt, Specs) {
	let FncD = {};
	FncD.TgtParent = $(ThisLmnt).find("div")[0];
	$(FncD.TgtParent).empty().css({ display: "flex", flexDirection: R$(Specs.FlexDx, "column"), justifyContent: "center", alignContent: "space-between", alignItems: "center", gap: R$(25, 40), minHeight: R$(window.innerHeight * .333, "auto"), color: "#fff", backgroundColor: Specs.BgColor, boxSizing: "border-box", padding: "1% 4%" });
	FncD.Video = $("<iframe>")
		.attr({ class: "Col Col1 Video", src: `https://www.youtube.com/embed/${Specs.YtId}?autoplay=1&mute=1&loop=1&playlist=${Specs.YtId}&enablejsapi=1`, title: "Wild Fed Horse Feed", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerpolicy: "strict-origin-when-cross-origin", allowfullscreen: true })
		.css({ flex: R$(1, ""), marginTop: R$("", 25), border: "none", borderRadius: 10, width: R$("", "100%") })
		.appendTo(FncD.TgtParent)[0];
	FncD.TextCol = $("<div>")
		.attr({ class: "Col Col2 TextCol" })
		.css({ flex: 1, display: "flex", flexDirection: "column", gap: R$(25, 40), justifyContent: "center", textAlign: "left" })
		.appendTo(FncD.TgtParent)[0];
	FncD.TextHeader = $("<h2>")
		.attr({ class: "TextHeader heading-block type--heading title--large" })
		.html(Specs.HeaderText)
		.appendTo(FncD.TextCol)[0];
	FncD.TextBody = $("<div>")
		.attr({ class: "TextBody text-block rte copy--medium " })
		.html(Specs.BodyText)
		.appendTo(FncD.TextCol)[0];
	$(FncD.Video).css({ height: FncD.Video.clientWidth * (9 / 16) });
	return FncD;
}

prjx447.Video.ANewStandardInHorseNutrition = function (ThisLmnt) {
	let FncD = {}, Specs;
	FncD.TgtParent = $(ThisLmnt).find("div")[0];
	Specs = {
		YtId: "BnWHpxNzCzc",
		BgColor: "rgb(98, 139, 55)",
		FlexDx: "row",
		HeaderText: "A New Standard in Horse Nutrition",
		BodyText: "<p>After years of working with horses and seeing the limitations of conventional feed, we knew there had to be a better way.</p><p>Wild Fed was created to bring horses back to a more natural, whole-food foundation—without unnecessary fillers, sugars, or shortcuts.</p><p>This video shares the heart behind our feed and what makes it truly different.</p>"
	};
	prjx447.Video.Create(ThisLmnt, Specs);
}

prjx447.Video.WhyWePutOats = function (ThisLmnt) {
	let FncD = {}, Specs;
	FncD.TgtParent = $(ThisLmnt).find("div")[0];
	Specs = {
		YtId: "eTy5KlqX12g",
		BgColor: "rgb(95, 75, 58)",
		FlexDx: "row-reverse",
		HeaderText: "Have a metabolically sensitive horse and wondering about the oats in our feed?",
		BodyText: "Watch this video as Dr. Wellspring explains why we include a small, intentional amount—and how our formula remains low NSC (~9.5–10) and safe for even sensitive horses."
	};
	prjx447.Video.Create(ThisLmnt, Specs);
}

prjx447.Video.JoniSiegal = function (ThisLmnt) {
	let FncD = {}, Specs;
	FncD.TgtParent = $(ThisLmnt).find("div")[0];
	Specs = {
		YtId: "nkzB_GnT0PM",
		BgColor: "rgb(95, 75, 58)",
		FlexDx: "row-reverse",
		HeaderText: "TBD Joni Siegal Video",
		BodyText: "TBD Joni Siegal Video"
	};
	prjx447.Video.Create(ThisLmnt, Specs);
}

prjx447.Video.WhyAddWater = function (ThisLmnt) {
	let FncD = {}, Specs;
	FncD.TgtParent = $(ThisLmnt).find("div")[0];
	Specs = {
		YtId: "f_388H74yZE",
		BgColor: "rgb(98, 139, 55)",
		FlexDx: "row",
		HeaderText: "Dr. Wellspring shares why a simple splash of water can transform how your horse receives their nutrition.",
		BodyText: "Wetting Wild Fed pellets enhances hydration, softens the feed for safer chewing, and supports smoother digestion and nutrient absorption. It also brings the feed closer to the natural moisture content of fresh forage—how horses are designed to eat.<br><br>No soaking required. Just add water, swish, and serve—an effortless step that supports comfort, safety, and whole-body health."
	};
	prjx447.Video.Create(ThisLmnt, Specs);
}

prjx447.Video.JulieLeeJourney = function (ThisLmnt) {
	let FncD = {}, Specs;
	FncD.TgtParent = $(ThisLmnt).find("div")[0];
	Specs = {
		YtId: "sZil9JtfDBo",
		BgColor: "rgb(95, 75, 58)",
		FlexDx: "row-reverse",
		HeaderText: "[TBD Julie Lee & Journey- Wild Fed Horse Feed Testimonial]",
		BodyText: "[TBD Julie Lee & Journey- Wild Fed Horse Feed Testimonial]"
	};
	prjx447.Video.Create(ThisLmnt, Specs);
}

prjx447.Video.WhatMakesWildFedHorseFeedDifferent = function (ThisLmnt) {
	let FncD = {}, Specs;
	FncD.TgtParent = $(ThisLmnt).find("div")[0];
	Specs = {
		YtId: "BnWHpxNzCzc",
		BgColor: "rgb(95, 75, 58)",
		FlexDx: "row",
		HeaderText: "Our Horse Feed",
		BodyText: "<b>What Makes It Different?</b><br><br>Our <b>Non-GMO Wild Fed Horse Feed</b> is formulated using only <b>whole foods</b>—ingredients your horse would naturally seek out in the wild. It's free of soy, corn, and sweeteners, and contains <b>no fillers or industry by-products</b>. Unlike traditional feeds, which rely on isolated synthetic nutrients, Wild Fed Horse Feed provides all the vitamins and minerals your horse needs from the feed itself, ensuring a richer, more complete nutrition profile."
	};
	let ThisD = prjx447.Video.Create(ThisLmnt, Specs);
	for (let Key in ThisD) FncD[Key] = ThisD[Key];
	FncD.ButtonsBar = $("<div>")
		.attr({ class: "ButtonsBar" })
		.css({ display: "flex", justifyContent: "flex-start", columnGap: 10 })
		.appendTo(FncD.TextCol)[0];
	FncD.Buttons = [
		{ Text: "FIND DEALER", Href: "https://wildfedhorse.com/pages/find-feed-dealer-page", Css: { color: FncD.TgtParent.style.backgroundColor, backgroundColor: "#fff" } },
		// { Text: "LEARN MORE", Href: "https://wildfedhorse.com/blogs/wild-fed-journal", Css: { color: "#fff", backgroundColor: "rgba(255,255,255,.2)" } }
	];
	FncD.Buttons.forEach((BtnD, BtnCreep) => {
		$("<a>")
			.attr({ class: "Btn Btn" + BtnCreep + " button", href: BtnD.Href })
			.css({})
			.css(BtnD.Css)
			.html(BtnD.Text)
			.appendTo(FncD.ButtonsBar)[0]
	});
}

prjx447.ProductsList = function (ThisLmnt) {
	let FncD = {};
	FncD.TgtParent = $(ThisLmnt).find("div")[0];
	$(FncD.TgtParent).empty().css({ textAlign: "center", color: "#fff", paddingTop: 0, marginBottom: R$("", 25) });
	FncD.CollectionHeader = $("<div>")
		.attr({ class: "h2 type--heading title--large container--page align--text-center prjx447CollectionHeader" })
		.css({ color: "rgb(86,75,66", marginTop: R$("2%", "2%"), marginBottom: R$("-3%", "3%") })
		.html("Our Product Collections")
		.appendTo(FncD.TgtParent)[0];
	FncD.CollectionBody = $("<div>")
		.attr({ class: "prjx447CollectionBody" })
		.css({ display: "flex", flexWrap: "wrap", justifyContent: "space-evenly", alignItems: "center", height: R$(380, "auto") })
		.appendTo(FncD.TgtParent)[0];
	FncD.OptionMap = [
		{ LabelTxt: "Wild Fed Horse Feed", ImgSrc: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/WIldFedHorseFeed-Big.jpg?v=1779989314", Href: "https://wildfedhorse.com/pages/wild-fed-feed-page" }, // 
		{ LabelTxt: "Wild Fed Organic Herbal Supplements", ImgSrc: "//cdn.shopify.com/s/files/1/0115/0202/6809/files/Supplements_Collection_Image.jpg?v=1789420936", Href: "https://wildfedhorse.com/collections/herbal-supplements" }, //cdn.shopify.com/s/files/1/0115/0202/6809/files/Herbs_on_wood.jpg?v=1748353662
		// { LabelTxt: "Wild Fed Hoodies", ImgSrc: "//cdn.shopify.com/s/files/1/0115/0202/6809/files/Wild_Fed_Cloud_Blue_Organic_Fleeced_Cotton_Sweatshirt.jpg?v=1734659108", Href: "https://wildfedhorse.com/collections/wild-fed-hoodies" },
	];
	FncD.OptionMap.forEach((OptionD, OptionCreep) => {
		OptionD.OptionLmnt = $("<a>")
			.attr({ class: "prjx447Option prjx447Option" + OptionCreep, href: OptionD.Href })
			.prop({ Data: OptionD })
			.css({ fontStyle: "normal", display: "block", width: R$("30%", "90%"), height: 222, margin: R$("", "1% 1%"), textAlign: "left", boxSizing: "border-box", padding: "1% 1.7%", backgroundImage: `url('${OptionD.ImgSrc}')`, backgroundSize: "cover", backgroundPosition: "center center", display: "flex", alignItems: "end" })
			.on({
				click: e => {
					Shopify.analytics.publish("prjx447Event", {
						InteractionType: "Click",
						InteractionName: "ProductClick: " + e.currentTarget.Data.LabelTxt,
						SectionId: "Product List",
						CustomData: {}
					});
				}
			})
			.appendTo(FncD.CollectionBody)[0];
		OptionD.LabelLmnt = $("<h3>")
			.attr({ class: "Label collection-card__title type--heading type--hyphenate link--no-underline" })
			.css({ color: "#fff", fontSize: R$(34, 27) })
			.html(OptionD.LabelTxt)
			.appendTo(OptionD.OptionLmnt)[0];
	});
}

prjx447.HomePageFeaturedCollection = function (ThisLmnt) {
	let FncD = {};
	FncD.Section = ThisLmnt;
	FncD.Div = $(ThisLmnt).find("div.featured-collection")[0];
	$(FncD.Section).css({ background: "rgb(95, 75, 58)" });
}

prjx447.HomePageFeaturedProducts = function (ThisLmnt) {
	return;
	$(ThisLmnt).find("a").each((Creep, ThisA) => {
		if (ThisA.href.indexOf("#judgeme_product_reviews") >= 0) {
			console.log("Found and removed");
			ThisLmnt.JudgeMeRemoved = true;
			$(ThisA).css({ display: "none" });
		}
	});
	if (ThisLmnt.JudgeMeRemoved) return;
	setTimeout(() => {
		prjx447.HomePageFeaturedCollection(ThisLmnt);
	}, 500)
}

prjx447.ContactUsInfo = function (ThisLmnt) {
	return;
}

prjx447.AddJudgeMeLinks = function (ThisLmnt) {
	$(ThisLmnt).find("li.cards__card-container").each((ContainerCreep, ContainerDiv) => {
		let ThisD = {};
		if ($(ContainerDiv).find("a").length > 0) {
			ThisD.A = $(ContainerDiv).find("a")[0];
		} else {
			return;
		}
		if (ThisD.A.href && ThisD.A.href.indexOf("sample") >= 0) {
			$(ContainerDiv).find(".product-card__reviews").css({ display: "none" });
		}
	});
}

prjx447.ReplaceDealerLocator = function (ThisLmnt) {
	let FncD = {};
	if (ThisLmnt.id.indexOf("__1742579240043caebb") >= 0) {
		//for https://wildfedhorse.com/pages/find-feed-dealer-page
		FncD.MainContentDiv = $("#MainContent").empty()[0];
		$("<div>")
			.attr({ class: "Header" })
			.css({ textAlign: "center", fontSize: R$("2.75em", "1.5em"), fontWeight: 900, color: "#fff", backgroundColor: "#5e4b3a", padding: ".25em 0", marginBottom: R$("1em", "1em") })
			.html("DEALER LOCATOR PAGE")
			.appendTo(FncD.MainContentDiv)[0];
		$("<iframe>")
			.on({
				load: e => {
					$(e.currentTarget).animate({ opacity: 1 });
				}
			})
			.attr({ class: "prjx447-DealerLocator", src: prjx447.ApiPath + "/address-map?DealerSearch" })
			.css({ display: "table", margin: "0 auto", border: "none", width: R$("65%", "100%"), height: R$(window.innerHeight * .75, window.innerHeight * .65), opacity: 0, borderRadius: R$(10, 0), marginBottom: R$("2em", "1.25em") })
			.appendTo(FncD.MainContentDiv)[0];
	} else if (ThisLmnt.id.indexOf("__custom_liquid_xbKwBw") >= 0) {
		$("<iframe>")
			.on({
				load: e => {
					$(e.currentTarget).animate({ opacity: 1 });
				}
			})
			.attr({ class: "prjx447-DealerLocator", src: prjx447.ApiPath + "/address-map?DealerSearch" })
			.css({ border: "none", display: "table", margin: "0 auto", width: R$("65%", "100%"), height: R$(window.innerHeight * .75, window.innerHeight * .65), opacity: 0 })
			.appendTo(ThisLmnt)[0];
	}
}

prjx447.HtmlToText = function (ThisHtml) {
	return new DOMParser().parseFromString(ThisHtml, "text/html").body.textContent;
}

prjx447.Blogs = function (ThisLmnt) {
	let FncD = {};
	{//PageTitle
		FncD.PageTitle = $("<h1>")
			.attr({ class: "PageTitle type--heading title--large align--text-center" })
			.html("Blog")
			.appendTo(ThisLmnt)[0];
	}
	{//UiBar
		FncD.UiBar = $("<div>")
			.attr({ class: "UiBar" })
			.css({ display: "flex", gap: 10, justifyContent: "center", margin: "1em 0" })
			.appendTo(ThisLmnt)[0];
		FncD.UiBar.Fnc = function () {
			$(ThisLmnt).find(".Article").each((ArticleCreep, ThisArticle) => {
				$(ThisArticle).css({ opacity: 0 });
				let ThisD = {};
				ThisD.SearchableText = [prjx447.HtmlToText(ThisArticle.Data.body), ThisArticle.Data.title, ThisArticle.Data.tags.join(" ")].join(" ");
				ThisD.FiltersMt = (FncD.UiBar.TextFilter.value == "" && FncD.UiBar.TagFilter.value == "");
				ThisD.FiltersBoth = (FncD.UiBar.TextFilter.value != "" && FncD.UiBar.TagFilter.value != "");
				ThisD.TextFilterMatch = (FncD.UiBar.TextFilter.value != "" && ThisD.SearchableText.toLowerCase().indexOf(FncD.UiBar.TextFilter.value.toLowerCase()) >= 0);
				ThisD.TagFilterMatch = FncD.UiBar.TagFilter.value != "" && ThisArticle.Data.tags.indexOf(FncD.UiBar.TagFilter.value) >= 0;
				console.log(ThisArticle.Data.tags, ThisArticle.Data);
				if (ThisD.FiltersMt) {
					if (ThisArticle.Data.tags.indexOf("Photo Contest") < 0) {
						ThisD.FilterVerdict = true;
					} else {
						ThisD.FilterVerdict = false;
					}
				} else if (ThisD.FiltersBoth) {
					ThisD.FilterVerdict = ThisD.TextFilterMatch && ThisD.TagFilterMatch;
				} else {
					ThisD.FilterVerdict = ThisD.TextFilterMatch || ThisD.TagFilterMatch;
				}
				if (ThisD.FilterVerdict) {
					$(ThisArticle).css({ display: "block" });
				} else {
					$(ThisArticle).css({ display: "none" });
				}
				$(ThisArticle).animate({ opacity: 1 });
			});
		}
		FncD.UiBar.TagFilter = $("<select>")
			.attr({ class: "TagFilter" })
			.prop({ Tags: ["Filter by Subject", "Horse Nutrition", "Digestive Health", "Metabolic Health", "Herbal Medicine", "Natural Horse Health", "Photo Contest"] })
			.css({ display: "inline-block", verticalAlign: "middle" })
			.on({
				change: e => {
					FncD.UiBar.TagFilter.options[0].innerHTML = "[Unfiltered]";
					FncD.UiBar.Fnc();
				}
			})
			.appendTo(FncD.UiBar)[0];
		FncD.UiBar.TagFilter.Tags.forEach((ThisTag, TagCreep) => {
			let ThisOp = $("<option>")
				.prop({ value: (TagCreep == 0 ? "" : ThisTag) })
				.html(ThisTag)
				.appendTo(FncD.UiBar.TagFilter)[0]
		});
		FncD.UiBar.TextFilter = $("<input>")
			.attr({ class: "TextFilter", placeholder: "Blog Search" })
			.css({ fontFamily: "inherit", fontSize: "1em", padding: 10, display: "inline-block", textAlign: "left", verticalAlign: "middle", width: R$("25%", "50%"), border: "1px solid #aaa", borderRadius: 5 })
			.on({
				keyup: e => {
					FncD.UiBar.Fnc();
				}
			})
			.appendTo(FncD.UiBar)[0];
	}
	{//Article Inits
		FncD.ArticleBig = $("<div>")
			.attr({ class: "ArticleBig" })
			.css({ display: "table", width: "80%", margin: "0 auto", marginTop: "1em", marginBottom: "2em", textAlign: "center" })
			.appendTo(ThisLmnt)[0];
		FncD.ArticleRows = $("<div>")
			.attr({ class: "ArticleRows" })
			.css({ display: "flex", flexWrap: "wrap", gap: 20, boxSizing: "border-box", justifyContent: "center" })
			.appendTo(ThisLmnt)[0];
	}
	{// Get & Stage Articles
		prjx447.Blogs.GetActive()
			.then(ThisReturn => {
				FncD.Articles = ThisReturn.data.articles.nodes;
				console.log("FncD.Articles", FncD.Articles);
				FncD.Articles.forEach((ArticleD, ArticleCreep) => {
					// console.log(ArticleD.summary, ArticleD.title);
					ArticleD.Href = "/blogs/" + ArticleD.blog.handle + "/" + ArticleD.handle;
					ArticleD.Lmnts = {};
					if (false) { // (R$(1, 2) == 1 && ArticleCreep == 0) {
						ArticleD.Lmnts.Parent = $("<div>")
							.attr({ class: "Article Parent" })
							.prop({ Data: ArticleD })
							.css({})
							.appendTo(FncD.ArticleBig)[0];
						ArticleD.Lmnts.Card = $("<div>")
							.attr({ class: "Card" })
							.css({ position: "relative", zIndex: 100, float: "right", width: "42%", backgroundColor: "rgb(95, 75, 58)", textAlign: "right", boxSizing: "border-box", padding: 32, marginRight: "7%", marginBottom: "-17%" })
							.appendTo(ArticleD.Lmnts.Parent)[0];
						ArticleD.Lmnts.Title = $("<a>")
							.attr({ class: "Title", href: ArticleD.Href })
							.prop({ Data: ArticleD })
							.css({ display: "block", fontSize: "1.6em", fontFamily: '"Hepta Slab", serif', color: "#fff", textDecoration: "none" })
							.html(ArticleD.title)
							.appendTo(ArticleD.Lmnts.Card)[0];
						ArticleD.Lmnts.Excerpt = $("<div>")
							.attr({ class: "Excerpt" })
							.prop({ Data: ArticleD })
							.css({ fontSize: "1em", fontFamily: "Lato, sans-serif", color: "#fff", marginTop: ".5em" })
							.appendTo(ArticleD.Lmnts.Card)[0];
						ArticleD.Lmnts.Excerpt.TextContent = prjx447.HtmlToText(ArticleD.body).split(" ");
						$(ArticleD.Lmnts.Excerpt).html(ArticleD.Lmnts.Excerpt.TextContent.slice(0, 18).join(" ") + "...");
						ArticleD.Lmnts.ReadMore = $("<a>")
							.attr({ class: "ReadMore", href: ArticleD.Href })
							.prop({ Data: ArticleD })
							.css({ display: "block", fontSize: "1em", fontFamily: "Lato, sans-serif", color: "#fff", marginTop: ".5em", textDecoration: "underline" })
							.html("Read More")
							.appendTo(ArticleD.Lmnts.Card)[0];
						ArticleD.Lmnts.ThumbLink = $("<a>")
							.attr({ class: "ThumbLink", href: ArticleD.Href })
							.css({ position: "relative", zIndex: parseInt(ArticleD.Lmnts.Card.style.zIndex) - 1, display: "block", textAlign: "center" })
							.appendTo(ArticleD.Lmnts.Parent)[0];
						ArticleD.Lmnts.Thumb = $("<img>")
							.attr({ class: "Thumb", src: ArticleD.image.url, alt: ArticleD.image.altText })
							.prop({ Data: ArticleD })
							.css({ display: "inline-block", width: "85%" })
							.appendTo(ArticleD.Lmnts.ThumbLink)[0];

					} else {
						ArticleD.Lmnts.Parent = $("<div>")
							.attr({ class: "Article Parent" })
							.prop({ Data: ArticleD })
							.css({ width: R$("30%", "100%"), textAlign: "center" })
							.appendTo(FncD.ArticleRows)[0];
						ArticleD.Lmnts.ThumbLink = $("<a>")
							.attr({ class: "ThumbLink", href: ArticleD.Href })
							.appendTo(ArticleD.Lmnts.Parent)[0];
						ArticleD.Lmnts.Thumb = $("<img>")
							.attr({ class: "Thumb", src: ArticleD.image.url, alt: ArticleD.image.altText })
							.prop({ Data: ArticleD })
							.css({ position: "relative", zIndex: 100 }) //, height: window.innerHeight * .40
							.on({
								load: e => {
									e.currentTarget.Data.ThumbSpecs = { ClientWidth: e.currentTarget.clientWidth, ClientHeight: e.currentTarget.clientHeight };
									if (typeof FncD.MaxHeight == "undefined") {
										FncD.MaxHeight = 0;
										FncD.MinHeight = 10000;
										FncD.LoadCount = 0;
									}
									FncD.MaxHeight = Math.max(FncD.MaxHeight, e.currentTarget.Data.ThumbSpecs.ClientHeight);
									FncD.MinHeight = Math.min(FncD.MinHeight, e.currentTarget.Data.ThumbSpecs.ClientHeight);
									FncD.LoadCount++;
									if (FncD.LoadCount >= FncD.Articles.length) {
										$(ThisLmnt).find(".Thumb").each((CreepThumbs, ThisThumb) => {
											ThisThumb.Data.ClipBottom = ThisThumb.clientHeight - FncD.MinHeight;
											if (ThisThumb.Data.ClipBottom > 0) {
												// $(ThisThumb).css({ clipPath: `inset(0px 0px ${ThisThumb.Data.ClipBottom}px 7%)`, marginBottom: (ThisThumb.Data.ClipBottom * -1) })
											}
										});
									}
								}
							})
							.appendTo(ArticleD.Lmnts.ThumbLink)[0];
						ArticleD.Lmnts.Card = $("<div>")
							.attr({ class: "Card" })
							.prop({ Data: ArticleD })
							.css({ position: "relative", textAlign: "left", color: "rgb(95, 75, 58)", backgroundColor: "#fff", padding: 15, boxSizing: "border-box", width: "93%", marginTop: "-15%", zIndex: parseInt(ArticleD.Lmnts.Thumb.style.zIndex) + 1 })
							.appendTo(ArticleD.Lmnts.Parent)[0];
						ArticleD.Lmnts.Title = $("<a>")
							.attr({ class: "Title", href: ArticleD.Href })
							.prop({ Data: ArticleD })
							.css({ display: "block", fontSize: "1.6em", fontFamily: '"Hepta Slab", serif', textDecoration: "none" })
							.html(ArticleD.title)
							.appendTo(ArticleD.Lmnts.Card)[0];
						ArticleD.Lmnts.Excerpt = $("<div>")
							.attr({ class: "Excerpt" })
							.prop({ Data: ArticleD })
							.css({ fontSize: "1em", fontFamily: "Lato, sans-serif", marginTop: ".5em" })
							.html(ArticleD.summary + "...")
							.appendTo(ArticleD.Lmnts.Card)[0];
						if (ArticleD.summary == "") {
							ArticleD.Lmnts.Excerpt.TextContent = prjx447.HtmlToText(ArticleD.body).split(" ");
							$(ArticleD.Lmnts.Excerpt).html(ArticleD.Lmnts.Excerpt.TextContent.slice(0, 20).join(" ") + "...");
						}
						ArticleD.Lmnts.ReadMore = $("<a>")
							.attr({ class: "ReadMore", href: ArticleD.Href })
							.prop({ Data: ArticleD })
							.css({ display: "block", fontSize: "1em", fontFamily: "Lato, sans-serif", marginTop: ".5em" })
							.html("Read More")
							.appendTo(ArticleD.Lmnts.Card)[0];
					}
				});
				FncD.UiBar.Fnc();
			})
			.catch(Err => {
				console.log("Err", Err);
			});
	}
}

prjx447.Blogs.GetActive = function () {
	return new Promise((Res, Rej) => {
		let FncD = {};
		FncD.AccessToken = "baf79b00f450bc7daa9da8f42519328d";
		FncD.ShopName = "wildfedhorse.myshopify.com";
		FncD.Cursor1 = "";
		FncD.Cursor2 = "";
		FncD.Cursor3 = "";
		FncD.Query = `
			query BlogArticleList${FncD.Cursor2} { 
				articles(first: 250${FncD.Cursor3}, sortKey: PUBLISHED_AT, reverse: true) { 
					pageInfo { hasNextPage hasPreviousPage startCursor endCursor } 
					nodes { id title 
						handle 
						summary: excerpt
						body: contentHtml
						tags 
						publishedAt 
						authorV2 { 
							name 
						} 
						image { 
							id 
							url 
							altText 
						} 
						blog { 
							id 
							title 
							handle 
						} 
					} 
				} 
			}
		`;
		FncD.Url = `https://${FncD.ShopName}/api/2024-04/graphql.json`;
		FncD.Headers = { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": FncD.AccessToken }
		FncD.Body = { query: FncD.Query };
		fetch(FncD.Url, {
			method: "post",
			headers: FncD.Headers,
			body: JSON.stringify(FncD.Body)
		})
			.then(ThisReturn => {
				return ThisReturn.json();
			})
			.then(ThisReturn => {
				Res(ThisReturn);
			})
			.catch(Err => {
				Rej(Err);
			});
	});
}

prjx447.ProductPageModifiers = function () {
	prjx447.ProductPageModifiers.ProductImageArrowsIcon();
	prjx447.ProductPageModifiers.YouTubes();
	prjx447.ProductPageModifiers.ServingsPerBag();
	prjx447.ProductPageModifiers.AddExtraJudgeMe();
	prjx447.ProductPageModifiers.GetDescriptionFromPrjx447();
}

prjx447.ProductPageModifiers.ProductImageArrowsIcon = function () {
	$(".button--slider.media-gallery__button")
		.css({ backgroundColor: "rgba(255, 255, 0, 0.05)", borderRadius: "50%", cursor: "pointer", zIndex: 100 })
		.on({
			click: e => {
				// $("media-gallery iframe").each((IframeCreep, ThisIfr) => {
				// 	console.log(ThisIfr.src);
				// });
				setTimeout(() => {
					$("media-gallery iframe").each((IframeCreep, ThisIfr) => {
						if (ThisIfr.src.indexOf("youtube.com") < 0) return;
						// let ThisMsg = { event: "command", func: "pauseVideo", args: "" };
						// ThisIfr.contentWindow.postMessage(JSON.stringify(ThisMsg), "*");
						$(ThisIfr)
							.attr({ src: ThisIfr.src.replace("autoplay=1", "autoplay=0") })
							.css({ border: "", borderRadius: 10 });
					});
				}, 0);
			}
		});
	$(".button--slider.media-gallery__button svg")
		.attr({ viewBox: "0 0 24 24", width: 60, height: 60 });
	$(".button--slider.media-gallery__button svg path")
		.attr({ stroke: "rgba(132, 255, 0, 0.5)", strokeWidth: 2 });
}

prjx447.ProductPageModifiers.YouTubes = function () {
	let FncD = {};
	FncD.MainSection = $(".section--main-product")[0];
	FncD.Iframes = $(".media-gallery__container iframe");//@@Narrow this to YouTubes
	if (FncD.Iframes.length > 0) {
		FncD.Iframes2 = $("<div>")
			.attr({ class: "Iframes2" })
			.css({ display: "flex", flexDirection: R$("row", "column"), justifyContent: "center", alignItems: "center", gap: 25, marginBottom: 25 })
			.appendTo(FncD.MainSection)[0];
		FncD.Iframes.each((CreepIframe1, ThisIframe1) => {
			let ThisIframe2 = $("<iframe>").appendTo(FncD.Iframes2)[0];
			$(ThisIframe2)
				.attr({ src: ThisIframe1.src, title: ThisIframe1.getAttribute("title"), allowfullscreen: "allowfullscreen", allow: "acceslerometer; autoplay; encrypted-media; gryoscope;  picture-in-picture" })
				.css({ borderRadius: 10, width: R$(window.innerWidth / (FncD.Iframes.length + 1), "80%"), boxShadow: "3px 3px 10px rgba(0,0,0,.3)" })
				.css({ height: ThisIframe2.clientWidth * (9 / 16) })
				.on({
					click: e => {
						// e.currentTarget.src = e.currentTarget.src.replace("mute=1", "mute=0")
					}
				});
		});
	}
}

prjx447.ProductPageModifiers.ServingsPerBag = function () {
	let FncD = {};
	FncD.Script = $(".prjx447-ServingsPerBag");
	if (FncD.Script.length == 0) return;
	FncD.Script = FncD.Script[0];
	FncD.ParentLmnt = FncD.Script.parentNode;
	FncD.ServingsDetail = $("<div>")
		.attr({ class: "ServingsDetail" })
		.appendTo(FncD.ParentLmnt)[0];
	FncD.ProductDetailLmnt = $(".featured-product__product-title")[0];
	FncD.ProductDetailHtml = FncD.ProductDetailLmnt.innerHTML;
	if (FncD.ProductDetailHtml.indexOf(" Supplement") >= 0 && FncD.ProductDetailHtml.indexOf("SAMPLE SIZE") < 0) {
		$(FncD.ServingsDetail)
			.css({ fontWeight: 900 }).html("60 Servings per Pound")
			.insertBefore($(".main-product__form")[0].childNodes[1]);
	}
}

prjx447.ProductPageModifiers.AddExtraJudgeMe = function () {
	let FncD = {};
	FncD.Script = $(".prjx447-ExtraJudgeMe");
	if (FncD.Script.length == 0) return;
	FncD.Script = FncD.Script[0];
	FncD.Parent = FncD.Script.parentNode;
	// FncD.JudgeMeSource = $(".jdgm-rev-widg__summary-stars");
	// console.log("FncD", FncD);
	// if (FncD.JudgeMeSource.length == 0) return;
	// FncD.JudgeMeSource = FncD.JudgeMeSource[0];
	FncD.ProductHandle = location.pathname.split("/").pop().split("?")[0];
	prjx447.GetProductByHandle(FncD.ProductHandle)
		.then(ThisReturn => {
			let ProductD = ThisReturn;
			FncD.Reviews = $("<a>")
				.attr({ class: "Reviews", href: "#judgeme_product_reviews" })//, href: "/products/" + ProductD.Handle 
				.prop({ Data: ThisReturn })
				.css({ textDecoration: "none", textAlign: "center", opacity: 0 })
				.animate({ opacity: 1 })
				.on({
					click: e => {
						Shopify.analytics.publish("prjx447Event", {
							InteractionType: "Click",
							InteractionName: "ProductClick: " + e.currentTarget.Data.Handle,
							SectionId: "Feed Page Product List",
							CustomData: {}
						});
					}
				})
				.appendTo(FncD.Parent)[0];
			if (ProductD.reviewCount.value >= 5) {
				FncD.ReviewStars = $("<div>")
					.attr({ class: "prjx447ReviewStars" })
					.css({ display: "inline-block" })
					.html(ProductD.badge.value)
					.appendTo(FncD.Reviews)[0];
				$(".jdgm-star").css({ color: "rgb(98, 139, 55)", margin: "0px 5px" });
				$(".jdgm-prev-badge__text").css({ display: "none" });
				FncD.ReviewCount = $("<div>")
					.attr({ class: "prjx447ReviewCount product-card__reviews-count copy--small" })
					.css({ display: "inline-block", marginLeft: 15 })
					.html(ProductD.reviewCount.value + " Reviews")
					.appendTo(FncD.Reviews)[0];
			}
		});
}

prjx447.ProductPageModifiers.GetDescriptionFromPrjx447 = function () {
	let FncD = {};
	FncD.MediaGallery = $("media-gallery");
	if (FncD.MediaGallery.length < 1) return;
	FncD.MediaGallery = FncD.MediaGallery[0];
	FncD.ProductId = FncD.MediaGallery.id.split("main-")[1];
	FncD.DescriptionDiv = $(".main-product__info .copy--medium.featured-product__block-spacing")
		.css({ opacity: 0 })[0];
	console.log("prjx447 Fetching ProductId", FncD.ProductId);
	FncD.Data = `Action=ShopifyProducts&Type=GetByProductId&ProductId=${FncD.ProductId}`;
	FncD.Payload = {
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
			"Accept": "application/json"
		},
		body: FncD.Data
	}
	console.log("Fetch Req", FncD.Payload);
	fetch(prjx447.ApiPath, FncD.Payload)
		.then(ThisReturn => {
			if (!ThisReturn.ok) throw ThisReturn.status;
			return ThisReturn.json();
		})
		.then(ThisReturn => {
			console.log("prjx447 Return", ThisReturn);
			if (ThisReturn.length != 1) throw { Error: "Fetch", Detail: "Fetched Records: " + ThisReturn.length, Request: FncD.Payload };
			FncD.PageData = ThisReturn[0];
			prjx447.dbug.push(FncD.DescriptionDiv);
			$(FncD.DescriptionDiv).empty();
			FncD.DescriptionDiv.Benefits = $("<div>")
				.attr({ class: "Benefits" })
				.css({ fontSize: "1.5em", fontWeight: 900 })
				.html("Benefits")
				.appendTo(FncD.DescriptionDiv)[0];
			FncD.DescriptionDiv.Traditionally = $("<div>")
				.attr({ class: "Traditionally" })
				.css({ fontSize: "1.1em", fontWeight: 900, margin: "1em 0" })
				.html("Traditionally used to support:")
				.appendTo(FncD.DescriptionDiv)[0];
			FncD.DescriptionDiv.Body = $("<div>")
				.attr({ class: "Body" })
				.html(prjx447.DbToHtml(ThisReturn[0].DescriptionBody))
				.appendTo(FncD.DescriptionDiv)[0];
			$(FncD.DescriptionDiv).animate({ opacity: 1 });
			FncD.YouTubeDiv = $(".Iframes2")[0];
			FncD.ProductTabs = $("<div>")
				.attr({ class: "ProductTabs" })
				.prop({ Data: FncD.PageData })
				.css({ opacity: 0, marginBottom: 40 })
				.animate({ opacity: 1 })
				.insertBefore(FncD.YouTubeDiv)[0];
			FncD.TabBar = $("<div>")
				.attr({ class: "TabBar" })
				.prop({ Data: FncD.PageData })
				.css({ fontFamily: "Avenir", textTransform: "uppercase", display: "flex", flexDirection: "row", justifyContent: "center", gap: 0, boxSizing: "border-box", padding: "0 1px", width: "100%", })
				.appendTo(FncD.ProductTabs)[0];
			FncD.TabStage = $("<div>")
				.attr({ class: "TabStage" })
				.prop({ Data: FncD.PageData })
				.css({ borderTop: "1px solid rgb(204, 204, 204)", marginTop: -1, boxSizing: "border-box", padding: 5, opacity: 0 })
				.appendTo(FncD.ProductTabs)[0];
			FncD.TabStage.Content = $("<div>")
				.attr({ class: "prjx447 Body Content" })
				.prop({ Data: FncD.PageData })
				.css({ display: "table", width: "50%", margin: "0 auto" })
				.appendTo(FncD.TabStage)[0];
			FncD.TabMap = [
				{ Label: "Organic Ingredients", CssContent: { width: R$("70%"/*"80%"*/, "80%") } },
				{ Label: "How To Use", CssContent: { width: R$("70%"/*"50%"*/, "80%") } },
				{ Label: "Research", CssContent: { width: R$("70%"/*"50%"*/, "80%") } }
			];
			FncD.TabMap.forEach((MapD, MapCreep) => {
				MapD.Class = MapD.Label.replace(/ /g, "");
				MapD.Stage = FncD.Stage;
				MapD.Tab = $("<div>")
					.attr({ class: "TabLabel TabLabel" + MapCreep }) // + " type--heading copy--small" 
					.prop({ Data: FncD.PageData, Map: MapD, Stage: FncD.TabStage })
					.css({ minWidth: 0, fontSize: R$("1.1em", ".85em"), fontWeight: R$(900, 900), padding: R$("10px 20px", "10px 20px"), boxSizing: "border-box", textAlign: "center", justifyContent: "center", display: "flex", alignItems: "center", borderTopLeftRadius: 8, border: "1px solid #ccc", borderTopRightRadius: 8, cursor: "pointer" })
					.html(MapD.Label)
					.on({
						click: e => {
							let ThisTab = e.currentTarget;
							$(".IngredientOverlay").remove();
							$(FncD.TabBar).find(".TabLabel").css({ color: "rgb(95, 75, 58)", backgroundColor: "#fff" });
							$(ThisTab).css({ color: "#fff", backgroundColor: "rgb(98, 139, 55)" });
							$(ThisTab.Stage).css({ opacity: 0 })
							$(ThisTab.Stage.Content).empty().css(ThisTab.Map.CssContent);
							prjx447.ProductPageModifiers["StageTab" + ThisTab.Map.Class](ThisTab);
							console.log("ThisTab.Data", ThisTab.Data)
							prjx447.ProductPageModifiers.XeqCss();
							$(ThisTab.Stage).animate({ opacity: 1 });
							// Shopify.analytics.publish("prjx447Event", {
							// 	InteractionType: "Click (" + (e.originalEvent.isTrusted ? "By User" : "By Default") + ")",
							// 	InteractionName: "Tab: " + ThisTab.Data.Label,
							// 	SectionId: "Feed Page Dynamic Tab UI",
							// 	CustomData: {}
							// });
						}
					})
					.appendTo(FncD.TabBar)[0];
			});
			// FncD.TabStage = $("<div>")
			// 	.attr({ class: "TabStage" })
			// 	.css({ borderTop: "1px solid #ccc", marginTop: -1, boxSizing: "border-box", padding: 15 })//, height: window.innerHeight * .5, overflowY: "scroll"
			// 	.appendTo(FncD.TgtParent)[0];
			$(FncD.TabBar).find(".TabLabel0")[0].click();
		})
		.catch(Err => {
			$(FncD.DescriptionDiv).animate({ opacity: 1 });
			console.log("FetchError:", Err);
		});
}

prjx447.ProductPageModifiers.StageTabOrganicIngredients = function (ThisTab) {
	$("<img>")
		.attr({ class: "Icon Ingredients", src: ThisTab.Data.IngredientsGfxUrl })
		.prop({ Data: ThisTab.Data })
		.on({
			mousemove: e => {
				return;
				let FncD = {};
				FncD.IngredientsGfx = e.currentTarget;
				FncD.MatchFound = false;
				FncD.GfxWidthPx = FncD.IngredientsGfx.Data.IngredientsGfxWidthPx;
				FncD.GfxHeightPx = FncD.IngredientsGfx.Data.IngredientsGfxHeightPx;
				FncD.MousePctX = Math.round(((e.originalEvent.clientX - FncD.IngredientsGfx.getBoundingClientRect().left) / FncD.IngredientsGfx.clientWidth) * 1000) / 10;
				FncD.MousePctY = Math.round(((e.originalEvent.clientY - FncD.IngredientsGfx.getBoundingClientRect().top) / FncD.IngredientsGfx.clientHeight) * 1000) / 10;
				FncD.IngredientsGfx.Data.Ingredients.forEach((IngredientD, IngredientCreep) => {
					if (typeof IngredientD.PctX == "undefined") {
						$(".IngredientOverlay").remove();
						IngredientD.PctX1 = ((IngredientD.XposPx - (IngredientD.WidthPx / 2)) / FncD.IngredientsGfx.Data.IngredientsGfxWidthPx) * 100;
						IngredientD.PctX2 = ((IngredientD.XposPx - (IngredientD.WidthPx / 2) + IngredientD.WidthPx) / FncD.IngredientsGfx.Data.IngredientsGfxWidthPx) * 100;
						IngredientD.PctY1 = ((IngredientD.YposPx - (IngredientD.HeightPx / 2)) / FncD.IngredientsGfx.Data.IngredientsGfxHeightPx) * 100;
						IngredientD.PctY2 = ((IngredientD.YposPx - (IngredientD.HeightPx / 2) + IngredientD.HeightPx) / FncD.IngredientsGfx.Data.IngredientsGfxHeightPx) * 100;
					}
					if (FncD.MousePctX >= IngredientD.PctX1 && FncD.MousePctX <= IngredientD.PctX2 && FncD.MousePctY >= IngredientD.PctY1 && FncD.MousePctY <= IngredientD.PctY2) {
						FncD.MatchFound = IngredientD;
					}
					if (FncD.MatchFound) {
						if (typeof FncD.IngredientsGfx.Overlay == "undefined") {
							FncD.IngredientsGfx.Overlay = $("<div>")
								.attr({ class: "IngredientOverlay" })
								.css({ position: "absolute", zIndex: 10000, cursor: "pointer", backdropFilter: "saturate(220%) contrast(110%)", borderRadius: "50%", padding: R$(50, 10), background: "circle at 20% 20%, rgba(255, 255, 255, 0.4) 0%, gba(255, 255, 255, 0.05) 50%, rgba(0, 0, 0, 0.1) 100%", boxShadow: "inset 0 10px 20px rgba(255, 255, 255, 0.5), inset 0 -10px 20px rgba(0, 0, 0, 0.1), 0 5px 35px rgba(0, 0, 0, 0.1)" })
								.on({
									click: e => {
										console.log(e.currentTarget.Data);
									}
								})
								.appendTo(document.body)[0];
						}
						if (FncD.IngredientsGfx.Overlay.parentNode == null) {
							$(FncD.IngredientsGfx.Overlay).appendTo(document.body)[0];
						}
						FncD.IngredientsGfx.Overlay.PosX1 = FncD.IngredientsGfx.getBoundingClientRect().left + (FncD.IngredientsGfx.clientWidth * FncD.MatchFound.PctX1 / 100);
						FncD.IngredientsGfx.Overlay.PosX2 = FncD.IngredientsGfx.getBoundingClientRect().left + (FncD.IngredientsGfx.clientWidth * FncD.MatchFound.PctX2 / 100);
						FncD.IngredientsGfx.Overlay.Width = FncD.IngredientsGfx.Overlay.PosX2 - FncD.IngredientsGfx.Overlay.PosX1;
						FncD.IngredientsGfx.Overlay.PosY1 = FncD.IngredientsGfx.getBoundingClientRect().top + (FncD.IngredientsGfx.clientHeight * FncD.MatchFound.PctY1 / 100);
						FncD.IngredientsGfx.Overlay.PosY2 = FncD.IngredientsGfx.getBoundingClientRect().top + (FncD.IngredientsGfx.clientHeight * FncD.MatchFound.PctY2 / 100);
						FncD.IngredientsGfx.Overlay.Height = FncD.IngredientsGfx.Overlay.PosY2 - FncD.IngredientsGfx.Overlay.PosY1;
						$(FncD.IngredientsGfx.Overlay)
							.prop({ Data: FncD.MatchFound })
							.css({ left: FncD.IngredientsGfx.Overlay.PosX1, top: FncD.IngredientsGfx.Overlay.PosY1 + window.scrollY, width: FncD.IngredientsGfx.Overlay.Width, height: FncD.IngredientsGfx.Overlay.Height });
						`<svg style="position: absolute; width: 0; height: 0;"><filter id="lens-filter" filterUnits="userSpaceOnUse">
    <!-- x, y, width, and height define the boundaries of the shift -->
    <feOffset id="lens-offset" dx="15" dy="-10" x="0" y="0" width="0" height="0" in="SourceGraphic" result="shifted" />
    
    <!-- Merge the shifted box back over the original untouched image -->
    <feMerge>
      <feMergeNode in="SourceGraphic" />
      <feMergeNode in="shifted" />
    </feMerge>
  </filter>
</svg>

<!-- The isolated image with the filter applied directly -->
<img src="your-image.jpg" alt="Target Image" id="target-image" class="filtered-img">
`
					}
				});
			},
			// mousemove: e => {
			// let FncD = {};
			// FncD.MatchFound = false;
			// FncD.IngredientsGfx = e.currentTarget;
			// if (typeof FncD.IngredientsGfx.ToolTip == "undefined") {
			// 	FncD.IngredientsGfx.ToolTip = $("<div>")
			// 		.attr({ class: "ToolTip" })
			// 		.css({ position: "absolute", zIndex: 10000, color: "rgb(37, 69, 6)", position: "fixed", width: "45%", border: "1px solid rgb(98, 139, 55)", borderRadius: 8, padding: 15, backgroundColor: "rgba(255, 255, 255, 1)" })
			// 		.appendTo(document.body)[0];
			// } else if (FncD.IngredientsGfx.ToolTip.parentNode == null) {
			// 	$(FncD.IngredientsGfx.ToolTip).appendTo(document.body);
			// }
			// FncD.GfxWidthPx = FncD.IngredientsGfx.Data.IngredientsGfxWidthPx;
			// FncD.GfxHeightPx = FncD.IngredientsGfx.Data.IngredientsGfxHeightPx;
			// FncD.MousePctX = Math.round(((e.originalEvent.clientX - FncD.IngredientsGfx.getBoundingClientRect().left) / FncD.IngredientsGfx.clientWidth) * 1000) / 10;
			// FncD.MousePctY = Math.round(((e.originalEvent.clientY - FncD.IngredientsGfx.getBoundingClientRect().top) / FncD.IngredientsGfx.clientHeight) * 1000) / 10;
			// FncD.IngredientsGfx.Data.Ingredients.forEach((IngredientD, IngredientCreep) => {
			// 	if (typeof IngredientD.PctX == "undefined") {
			// 		IngredientD.PctX1 = ((IngredientD.XposPx - (IngredientD.WidthPx / 2)) / FncD.IngredientsGfx.Data.IngredientsGfxWidthPx) * 100;
			// 		IngredientD.PctX2 = ((IngredientD.XposPx - (IngredientD.WidthPx / 2) + IngredientD.WidthPx) / FncD.IngredientsGfx.Data.IngredientsGfxWidthPx) * 100;
			// 		IngredientD.PctY1 = ((IngredientD.YposPx - (IngredientD.HeightPx / 2)) / FncD.IngredientsGfx.Data.IngredientsGfxHeightPx) * 100;
			// 		IngredientD.PctY2 = ((IngredientD.YposPx - (IngredientD.HeightPx / 2) + IngredientD.HeightPx) / FncD.IngredientsGfx.Data.IngredientsGfxHeightPx) * 100;
			// 	}
			// 	if (FncD.MousePctX >= IngredientD.PctX1 && FncD.MousePctX <= IngredientD.PctX2 && FncD.MousePctY >= IngredientD.PctY1 && FncD.MousePctY <= IngredientD.PctY2) {
			// 		FncD.MatchFound = true;
			// 		$(FncD.IngredientsGfx.ToolTip).empty();
			// 		// $("<div>")
			// 		// 	.attr({ class: "Stats" })
			// 		// 	.css({ position: "absolute", left: 0, top: 0, fontSize: ".8em" })
			// 		// 	.html(`Mouse: (${FncD.MousePctX},${FncD.MousePctY})<br>(${Math.round(IngredientD.PctX1)},${Math.round(IngredientD.PctX2)})<br>(${Math.round(IngredientD.PctY1)},${Math.round(IngredientD.PctY2)})`)
			// 		// 	.appendTo(FncD.IngredientsGfx.ToolTip)[0]
			// 		$("<div>")
			// 			.attr({ class: "Ingredient" })
			// 			.css({ color: "rgb(98, 139, 55)", fontSize: "1.15em", fontWeight: 900, textAlign: "center" })
			// 			.html(prjx447.DbToHtml(IngredientD.Ingredient))
			// 			.appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		if (IngredientD.LatinName != "") {
			// 			$("<div>")
			// 				.attr({ class: "LatinName" })
			// 				.css({ color: "rgb(98, 139, 55)", fontSize: ".9em", fontWeight: 900, textAlign: "center", fontStyle: "italic" })
			// 				.html("(" + prjx447.DbToHtml(IngredientD.LatinName) + ")")
			// 				.appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		}
			// 		$("<div>")
			// 			.attr({ class: "ResearchBrief" })
			// 			.css({ fontSize: ".9em", textAlign: "center" })
			// 			.html(prjx447.DbToHtml(IngredientD.ResearchBrief))
			// 			.appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		$("<hr>").appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		$("<div>")
			// 			.attr({ class: "SupportingEvidence" })
			// 			.css({ fontSize: ".9em", fontWeigth: 900 })
			// 			.html(prjx447.DbToHtml(IngredientD.SupportingEvidence))
			// 			.appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		$("<hr>").appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		$("<div>")
			// 			.attr({ class: "Description" })
			// 			.css({ fontSize: ".9em" })
			// 			.html(prjx447.DbToHtml(IngredientD.Description))
			// 			.appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		$("<hr>").appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		$("<div>")
			// 			.attr({ class: "ResearchIntro" })
			// 			.css({ fontSize: ".9em" })
			// 			.html(prjx447.DbToHtml(IngredientD.ResearchIntro))
			// 			.appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		$("<hr>").appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		FncD.IngredientsGfx.ToolTip.ResearchBlock = $("<div>")
			// 			.attr({ class: "ResearchBlock" })
			// 			.css({ fontSize: ".9em" })
			// 			.appendTo(FncD.IngredientsGfx.ToolTip)[0];
			// 		let PriorType, TypeCount, SourceRow;
			// 		IngredientD.ResearchSources.forEach((SourceD, SourceCreep) => {
			// 			if (SourceD.Type != PriorType) {
			// 				$("<div>")
			// 					.attr({ class: "SourceType" })
			// 					.css({ fontWeight: 900, marginTop: (TypeCount ? 5 : 0) })
			// 					.html(SourceD.Type)
			// 					.appendTo(FncD.IngredientsGfx.ToolTip.ResearchBlock)[0];
			// 				TypeCount = 1;
			// 			} else {
			// 				TypeCount++;
			// 			}
			// 			PriorType = SourceD.Type;
			// 			SourceRow = $("<div>")
			// 				.attr({ class: "SourceRow" })
			// 				.css({ fontSize: ".9em" })
			// 				.html(TypeCount + "&nbsp;&nbsp;&nbsp;&nbsp;")
			// 				.appendTo(FncD.IngredientsGfx.ToolTip.ResearchBlock)[0];
			// 			SourceRow.Source = $("<span>")
			// 				.attr({ class: "Source" })
			// 				.html(prjx447.DbToHtml(SourceD.Source))
			// 				.appendTo(SourceRow)[0];
			// 			if (SourceD.Year) {
			// 				SourceRow.Year = $("<span>")
			// 					.attr({ class: "Year" })
			// 					.css({ marginLeft: 5 })
			// 					.html(SourceD.Year + ".")
			// 					.appendTo(SourceRow)[0];
			// 			}
			// 		});
			// 	}
			// });
			// if (FncD.MatchFound) {
			// 	if (e.pageX < window.innerWidth / 2) {
			// 		FncD.MouseX = e.pageX + 20
			// 	} else {
			// 		FncD.MouseX = e.pageX - FncD.IngredientsGfx.ToolTip.clientWidth - 20
			// 	}
			// 	FncD.MouseY = (window.innerHeight / 2) - (FncD.IngredientsGfx.ToolTip.clientHeight / 2);
			// 	$(FncD.IngredientsGfx.ToolTip).find("hr").css({ border: ".5px solid rgb(98, 139, 55)", width: "50%", margin: "10px auto" })
			// 	$(FncD.IngredientsGfx.ToolTip).css({ display: "block", left: FncD.MouseX, top: FncD.MouseY });
			// } else {
			// 	$(FncD.IngredientsGfx.ToolTip).css({ display: "none" });
			// }
			// },
			mouseout: e => {
				// $(e.currentTarget.Overlay).remove();
				// $(e.currentTarget.ToolTip).remove();
			}
		})
		.appendTo(ThisTab.Stage.Content)[0];
}

prjx447.ProductPageModifiers.StageTabHowToUse = function (ThisTab) {
	$("<img>")
		.attr({ class: "DosingGuidelines", src: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/DosingGuidelines-15.png?v=1779813984" })
		.css({ display: "table", margin: "0 auto", width: R$("70%", "100%"), })
		.appendTo(ThisTab.Stage.Content)[0];
	let ThisMap = [
		{ Id: 17, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Leaf-17.svg?v=1779813983", Header: "Dose Matters", Body: "If you do not notice change in your horse's symptoms, do not hesitate to increase the dose.  All horses respond differently to herbs.  Some are very sensitive and require a smaller dose but some are not as sensitive or are much bigger in size and need a bigger dose.  Before you decide the formula doesn't work, try increasing the dose." },
		{ Id: 21, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Scoop-21.svg?v=1779813983", Header: "Loading Dose", Body: "You may choose to start with a loading dose which would be doing a double dose for the first 1-2 weeks so that the herbs can accumulate in the system and start taking effect faster. Depending on the severity of the condition you may stay at the loading dose for longer.  Reduce to a maintenance dose after symptoms become well managed." },
		{ Id: 19, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Clock-19.svg?v=1779813983", Header: "Frequency Matters", Body: "The more often you can administer the supplement the better it will work.  Administering two times/day is ideal. One time per day could still be helpful but the supplement's effects wear off after about 6-8 hours.  If feeding more than one time per day is not an option, double up on the dose." },
		{ Id: 23, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Horse-23.svg?v=1779813983", Header: "Picky Eaters", Body: "If your horse refuses the herbs or you know they are picky eaters, start with a smaller dose and work your way up to the full dosage over 1-2 weeks.  For example, you may start with 1⁄4 or even 1/8th of a scoop and increase the dose daily until you reach full dose.  This way your horse can adjust to the taste over time." },
		{ Id: 27, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Calendar-27.svg?v=1779813983", Header: "Time Delay", Body: "Some formulas such as Chill out Dude you will notice a change in 30-60 minutes but all the other formulas take time before you will notice results.  Expect to see some initial changes in 2-4 weeks.  After 2-3 months you will see the full potential of what the herbs can do." },
		{ Id: 25, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Splash-25.svg?v=1779813983", Header: "Do I Need To Wet The Herbs", Body: "We highly recommend it.  A quick splash is all you need, no soaking required.  It helps herbs stick to feed, prevents them from falling to the bottom the bowl, and reduces the chance of herbs sticking to the roof of your horse's mouth.  You can also sprinkle over hay, but you may lose some of the herbs this way." },
	];
	ThisMap.forEach((MapD, MapCreep) => {
		MapD.Row = $("<div>")
			.attr({ class: "HowToRow" })
			.css({ margin: "15px 0", display: "flex", alignItems: "start" })
			.appendTo(ThisTab.Stage.Content)[0];
		MapD.Row.Img = $("<img>")
			.attr({ class: "Icon Icon" + MapD.Id, src: MapD.Url })
			.css({ width: R$(75, 85), paddingRight: 10, paddingTop: 5 })
			.appendTo(MapD.Row)[0];
		MapD.Row.Text = $("<div>")
			.attr({ class: "Row" })
			.appendTo(MapD.Row)[0];
		$("<span>")
			.attr({ class: "Header" })
			.css({ fontSize: "1.5em", fontWeight: 900 })
			.html(MapD.Header.toUpperCase())
			.appendTo(MapD.Row.Text)[0];
		$("<div>")
			.attr({ class: "Body" })
			.html(MapD.Body)
			.appendTo(MapD.Row.Text)[0];
	})
}

prjx447.ProductPageModifiers.StageTabResearch = function (ThisTab) {
	let FncD = {};
	FncD.Header = $("<div>")
		.attr({ class: "IntroResearch Header" })
		.css({ fontSize: "1.5em", fontWeight: 900, textAlign: "center", marginTop: "1.5em" })
		.html("Rooted in Tradition<br>Guided by Science")
		.appendTo(ThisTab.Stage.Content)[0];
	FncD.SubHeader = $("<div>")
		.attr({ class: "IntroResearch SubHeader" })
		.css({ fontSize: "1.25em", fontWeight: 900, textAlign: "center", marginBottom: "1.5em" })
		.html("Take a deeper look into the science behind each ingredient in the formula")
		.appendTo(ThisTab.Stage.Content)[0];
	ThisTab.Data.Ingredients.forEach((IngredientD, IngredientCreep) => {
		if (IngredientCreep > 0) {
			$("<hr>")
				.css({ width: "75%", margin: "3.5em auto 2em", border: "1px solid rgb(98, 139, 55)" })
				.appendTo(ThisTab.Stage.Content)[0];
		}
		IngredientD.IngredientParent = $("<div>")
			.attr({ class: "IngredientParent" })
			.css({ marginTop: 10 })
			.appendTo(ThisTab.Stage.Content)[0];
		IngredientD.IngredientDiv = $("<div>")
			.attr({ class: "IngredientDiv" })
			.css({ fontSize: "1.5em", fontWeight: 900, color: "rgb(98, 139, 55)" })
			.html(IngredientD.Ingredient)
			.appendTo(IngredientD.IngredientParent)[0];
		if (IngredientD.LatinName != "") {
			IngredientD.LatinNameDiv = $("<div>")
				.attr({ class: "LatinName" })
				.css({ fontSize: "1.15em", fontStyle: "italic", color: "rgb(98, 139, 55)" })
				.html("(" + IngredientD.LatinName + ")")
				.appendTo(IngredientD.IngredientParent)[0];
		}
		IngredientD.ResearchBriefDiv = $("<div>")
			.attr({ class: "ResearchBrief" })
			.css({ fontSize: "1.15em", fontWeight: 900, color: "rgb(98, 139, 55)" })
			.html(prjx447.DbToHtml(IngredientD.ResearchBrief))
			.appendTo(IngredientD.IngredientParent)[0];
		IngredientD.ResearchIntroDiv = $("<div>")
			.attr({ class: "ResearchIntro" })
			.css({ fontSize: "1.15em", margin: ".5em 0" })
			.html(prjx447.DbToHtml(IngredientD.ResearchIntro))
			.appendTo(IngredientD.IngredientParent)[0];
		IngredientD.ResearchHighlightsHeader = $("<div>")
			.attr({ class: "ResearchHighlightsHeader" })
			.css({ fontSize: "1.25em", fontWeight: 900, marginTop: ".5em" })
			.html("Research Highlights")
			.appendTo(IngredientD.IngredientParent)[0];
		IngredientD.ResearchHighlightsDiv = $("<div>")
			.attr({ class: "ResearchHighlightsDiv" })
			.css({})
			.html("<div class='ResearchHighlight'> • " + IngredientD.ResearchHighlights.replace(/\r/g, "\n").split("\n").join("</div><div class='ResearchHighlight'> • ") + "</div>")
			.appendTo(IngredientD.IngredientParent)[0];
		IngredientD.ResearchSourcesHeader = $("<div>")
			.attr({ class: "ResearchSourcesHeader" })
			.css({ fontSize: "1.25em", fontWeight: 900, marginTop: ".5em" })
			.html("Original Journal Articles")
			.appendTo(IngredientD.IngredientParent)[0];
		IngredientD.ResearchSourcesDiv = $("<div>")
			.attr({ class: "ResearchSourcesDiv" })
			.appendTo(IngredientD.IngredientParent)[0];
		IngredientD.ResearchSources.forEach((SourceD, SourceCreep) => {
			if (SourceD.Type != IngredientD.ResearchSourcesDiv.PriorType) {
				$("<div>")
					.attr({ class: "ResearchType" })
					.css({ fontSize: "1.25", fontWeight: 900 })
					.html(SourceD.Type)
					.appendTo(IngredientD.ResearchSourcesDiv)[0]
			}
			IngredientD.ResearchSourcesDiv.PriorType = SourceD.Type
			SourceD.ResearchRow = $("<div>")
				.attr({ class: "ResearchRow" })
				.appendTo(IngredientD.ResearchSourcesDiv)[0];
			SourceD.ResearchRow.RowNum = $("<span>")
				.attr({ class: "RowNum" })
				.css({ marginRight: "1em" })
				.html(SourceCreep + 1)
				.appendTo(SourceD.ResearchRow)[0]
			SourceD.ResearchRow.Source = $("<span>")
				.attr({ class: "Source" })
				.css({})
				.html(prjx447.DbToHtml(SourceD.Source))
				.appendTo(SourceD.ResearchRow)[0]
			if (SourceD.Year) {
				SourceD.ResearchRow.Year = $("<span>")
					.attr({ class: "Year" })
					.css({ fontSize: ".9em" })
					.html(prjx447.DbToHtml(SourceD.Year))
					.appendTo(SourceD.ResearchRow)[0];
			}
		});
	});
}

prjx447.ProductPageModifiers.XeqCss = function () {
	let FncD = {};
	FncD.TabStage = $("#MainContent .ProductTabs .TabStage")[0];
	$("introhowtouse").css({ display: "table", width: R$("32%", "100%"), fontSize: R$("", ".8em"), margin: "25px auto 0", padding: 25, borderRadius: 10, backgroundColor: "rgba(101,140,58,0.1)" });
	$("introresearch").css({ display: "table", fontSize: R$("", ".8em"), margin: "25px auto 0", padding: 25, borderRadius: 10, backgroundColor: "rgba(101,140,58,0.1)" });
	$("bighead").css({ fontSize: "1.5em", fontWeight: 900 });
	$("midhead").css({ fontSize: "1.25em", fontWeight: 900 });
	$("smallhead").css({ fontSize: "1.1em", fontWeight: 900 });
	// $(".DosingGuidelines")
	// 	.css({ width: R$("70%", "100%") })
	// 	.attr({ src: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/DosingGuidelines-15.png?v=1779813984" });
	// FncD.ImgMap = [
	// 	// { Id: 15, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/DosingGuidelines-15.png?v=1779813984" },
	// 	{ Id: 17, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Leaf-17.svg?v=1779813983" },
	// 	{ Id: 19, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Clock-19.svg?v=1779813983" },
	// 	{ Id: 21, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Scoop-21.svg?v=1779813983" },
	// 	{ Id: 23, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Horse-23.svg?v=1779813983" },
	// 	{ Id: 25, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Splash-25.svg?v=1779813983" },
	// 	{ Id: 27, Url: "https://cdn.shopify.com/s/files/1/0115/0202/6809/files/Icon-Calendar-27.svg?v=1779813983" },
	// ];
	// FncD.ImgMap.forEach((MapD, MapCreep) => {
	// 	$("img.Icon.Icon" + MapD.Id)
	// 		.attr({ src: MapD.Url })
	// 		.css({ float: "left", width: R$(75, 85), paddingRight: 10, paddingTop: 5 });
	// });
}

prjx447.YouTubeObserver = function () {
	let FncD = {};
	window.onYouTubeIframeAPIReady = function () {
		prjx447.YouTubeObserver.CheckAllYts()
	}
	$("script")
		.each((ScriptCreep, ThisScript) => {
			if (ThisScript.src.indexOf("https://youtube.com/iframe_api") == 0) {
				FncD.YtScriptExists = ThisScript;
			}
		});
	if (typeof FncD.YtScriptExists == "undefined") {
		$("<script>")
			.on({
				load: e => {
					// $("iframe").each((IframeCreep, ThisIframe) => {
					// 	// console.log(IframeCreep, "OnLoad", ThisIframe);
					// 	// prjx447.YouTubeObserver.CheckYt(ThisIframe);
					// });
				}
			})
			.appendTo(document.head)
			.attr({ class: "YtScript", src: "https://youtube.com/iframe_api" })[0];
	}
}

prjx447.YouTubeObserver.CheckAllYts = function () {
	$("iframe").each((IframeCreep, ThisIframe) => {
		// console.log(IframeCreep, "onYouTubeIframeAPIReady", ThisIframe);
		prjx447.YouTubeObserver.CheckYt(ThisIframe);
	});
	setTimeout(() => {
		prjx447.YouTubeObserver.CheckAllYts();
	}, 1000);
}

prjx447.YouTubeObserver.CheckYt = function (ThisIframe) {
	if (ThisIframe.src.indexOf("https://www.youtube.com/embed/") < 0) return;
	if (typeof ThisIframe.prjx447GaPrepped != "undefined") return;
	if (typeof YT == "undefined" || typeof YT.Player == "undefined") {
		console.log("YT.Player not yet avail");
		return;
	}
	ThisIframe.prjx447GaPrepped = true;
	let FncD = {};
	FncD.Iframe = ThisIframe;
	// FncD.LmntId = ThisIframe.id;
	FncD.YtId = ThisIframe.src.split("?")[0].split("/").pop();
	FncD.Player = new YT.Player(FncD.Iframe, { events: { onStateChange: (e) => { prjx447.YouTubeObserver.prjx447Prep(e) } } });
	console.log("Observing YouTube", FncD.Iframe.src);
}

prjx447.YouTubeObserver.prjx447Prep = function (e, SentD) {
	let FncD = {};
	// window.addEventListener("message", function (event) {
	// 	console.log("IframeMessage", event);
	// })
	FncD.e = e;
	FncD.Target = e.target;
	FncD.Iframe = e.target.g;
	FncD.GoogleData = {};
	FncD.GoogleData.InteractionType = "YouTube";
	FncD.GoogleData.InteractionName = "Video State Change";
	FncD.GoogleData.SectionId = "YouTube " + e.target.playerInfo.videoData.video_id;
	FncD.GoogleData.VideoId = e.target.playerInfo.videoData.video_id;
	FncD.GoogleData.VideoTitle = e.target.playerInfo.videoData.title;
	["Playing", "Paused", "Ended"].forEach((ThisState) => {
		if (e.data == YT.PlayerState[ThisState.toUpperCase()]) FncD.GoogleData.VideoState = ThisState;
	});
	FncD.GoogleData.VideoTime = e.target.playerInfo.currentTime;
	FncD.GoogleData.VideoDuration = e.target.playerInfo.duration;
	FncD.GoogleData.VideoVolume = e.target.playerInfo.volume;
	FncD.GoogleData.VideoMuted = e.target.playerInfo.muted;
	try {
		FncD.GoogleData.Width = e.target.playerInfo.size.width;
		FncD.GoogleData.Height = e.target.playerInfo.size.height;
	} catch (e) {
		console.log(e, "e.target.playerInfo", e.target.playerInfo);
	}
	FncD.GoogleData.CustomData = {};
	Shopify.analytics.publish("prjx447Event", FncD.GoogleData);
}

prjx447.MenuObserver = function () {
	return;
	if (!prjx447.MenuObserver.Matches) prjx447.MenuObserver.Matches = 0;
	let ThisDevice = R$("Desktop", "Mobile");
	if (ThisDevice == "Desktop") {
		//Desktop
		$(".site-header__dropdown-menu-list-item")[8].childNodes[0].setAttribute("target", "_blank"); // open Wild Fed YouTube channel in new tab/window 
		$(".site-header__dropdown-menu-list-item")[9].style.display = "none"; //hide /pages/books-we-love
		$(".site-header__dropdown-menu-list-item")[10].style.display = "none"; // hide Photo Contest Winners
	} else {
		//Mobile
		$("#menu-drawer .drawer-menu__main-dropdown-list-item")[12].childNodes[0].setAttribute("target", "_blank"); // open Wild Fed YouTube channel in new tab/window 
		$("#menu-drawer .drawer-menu__main-dropdown-list-item")[13].style.display = "none";  //hide /pages/books-we-love
		$("#menu-drawer .drawer-menu__main-dropdown-list-item")[14].style.display = "none"; // hide Photo Contest Winners
	}
}

prjx447.InitCustomSections = function (ThisLmnt) {
	let ThisMap = [
		{ LiquidId: "dQfm8j", Fnc: prjx447.UpdateHomePageIntro, Where: ["/"] },
		{ LiquidId: "wW6FFc", Fnc: prjx447.ProductsList, Where: ["/"] },
		{ LiquidId: "cQaLJg", Fnc: prjx447.HorseFeedProducts, Where: ["tbd"] },
		{ LiquidId: "K3knQd", Fnc: prjx447.TabsInFeedPage, Where: ["tbd"] },
		{ LiquidId: "GQAryr", Fnc: prjx447.Video.ANewStandardInHorseNutrition, Where: ["tbd"] },
		{ LiquidId: "3jUWJG", Fnc: prjx447.Video.WhatMakesWildFedHorseFeedDifferent },
		{ LiquidId: "z7UpHR", Fnc: prjx447.Video.WhyWePutOats },
		{ LiquidId: "LNWCFk", Fnc: prjx447.Video.WhyAddWater },
		{ LiquidId: "REdWgW", Fnc: prjx447.Video.JulieLeeJourney },
		{ LiquidId: "FX8Rz4", Fnc: prjx447.ContactUsInfo, Where: ["/pages/contact-us"] },
		{ LiquidId: "xbKwBw", Fnc: prjx447.ReplaceDealerLocator, Where: ["/pages/wild-fed-feed-page"] },
		{ LiquidId: "XVwnJy", Fnc: prjx447.HomePageFeaturedProducts, Where: ["/"] },
		{ LiquidId: "E3dNmH", Fnc: prjx447.DiscoverTheWildFedDifference, Where: ["/"] },
		{ LiquidId: "Gf9WKj", Fnc: prjx447.Blogs, Where: ["/blogs/wild-fed-journal"] },
		{ LmntId: "__1742579240043caebb", Fnc: prjx447.ReplaceDealerLocator, Where: ["/pages/find-feed-dealer-page"] },
		{ LmntId: "shopify\-section\-template\-\-[0-9]{14}__product\-grid", Fnc: prjx447.AddJudgeMeLinks, Where: ["/collections/herbal-supplements"] },
		{ LmntId: "shopify\-section\-template\-\-[0-9]{14}__featured_collection", Fnc: prjx447.AddJudgeMeLinks, Where: ["/"] },
		{ LmntId: "shopify\-section\-template\-\-[0-9]{14}__image_banner", Fnc: prjx447.HomePageHeader, Where: ["/"] },
		{ LmntId: "shopify\-section\-template\-\-[0-9]{14}__icon-list", Fnc: prjx447.HomePageIconList, Where: ["/", "?all product pages?"] },
		// { LmntId: "shopify-section-template--18141708714184__featured_collection", Fnc: prjx447.HomePageFeaturedCollection, Where: ["/"] },
	];
	ThisMap.forEach((MapD) => {
		if (MapD.LiquidId && ThisLmnt.id.substr((MapD.LiquidId.length + 1) * -1) == "_" + MapD.LiquidId) {
			MapD.Fnc(ThisLmnt);
		} else if (MapD.Class && $("." + MapD.Class).length == 1) {
			MapD.Fnc(ThisLmnt);
		} else if (MapD.LmntId && ThisLmnt.id.match(new RegExp(MapD.LmntId, "g")) != null) {
			MapD.Fnc(ThisLmnt);
		}
	});
}

//Inits

prjx447.FeedIngredients = ["Ingredients", "NON-GMO Orchard Grass", "NON-GMO Timothy Grass", "NON-GMO Alfalfa", "NON-GMO Oats", "Sunflower Seeds", "Chia Seeds", "Proprietary mix of Organic Herbs", "Organic Selenium Yeast", "Zinc Methionine", "Copper Glycinate", "Organic Probiotic and Trace Mineral Salt"];
prjx447.FeedIngredientsHtml = `<div class="Ingredients"><p><strong>Ingredients:</strong></p><p>NON-GMO Orchard Grass, NON-GMO Timothy Grass, NON-GMO Alfalfa, NON-GMO Oats, Sunflower Seeds, Chia Seeds, Proprietary mix of Organic Herbs, Organic Selenium Yeast, Zinc Methionine, Copper Glycinate, Organic Probiotic and Trace Mineral Salt.</p><p><strong>Our Promise:</strong></p><ul><li><strong>ORGANIC</strong> and <strong>NON-GMO</strong> ingredients</li><li><strong>FREE OF</strong> corn, soy, sweeteners and industry by-products</li><li>Appropriate for horses of <strong>ALL AGES</strong></li><li><strong>HIGH IN CALORIES</strong> averaging at 1400 cal/lb</li><li><strong>LOW IN SUGAR</strong> content- can be used for Insulin resistant and Cushing's horses</li><li><strong>ENHANCED WITH Organic PROBIOTICS</strong></li><li>Made with <strong>ORGANIC HERBS</strong> and <strong>CHIA SEEDS</strong></li></ul></div>`;
prjx447.FeedNutrientProfile = [{ Nutrient: "NUTRIENT", Val: "VALUE" }, { Nutrient: "Protein (min)", Val: "12.5%" }, { Nutrient: "Crude Fat (min)", Val: "4.5%"/*3.2%*/ }, { Nutrient: "Calcium (min/max)", Val: "0.4 - 0.9%" }, { Nutrient: "Phosphorus (min)", Val: "0.22%" }, { Nutrient: "Salt (max)", Val: "0.4%" }, { Nutrient: "Copper (min)", Val: "6.5ppm" }, { Nutrient: "Zinc (min)", Val: "25ppm" }, { Nutrient: "Selenium (min)", Val: "0.3ppm" }, { Nutrient: "Vit A (min)", Val: "7000 IU/lb" }, { Nutrient: "Vit D (min)", Val: "429 IU/lb" }, { Nutrient: "NSC (max)", Val: "13%" }, { Nutrient: "ESC (max)", Val: "8%" }, { Nutrient: "Starch (max)", Val: "2%" }];
{//Section Handler
	document.querySelectorAll(".shopify-section").forEach(prjx447.InitCustomSections);
	prjx447.ObserverM = new MutationObserver((Mutations) => {
		Mutations.forEach((Mutation) => {
			Mutation.addedNodes.forEach((Node) => {
				if (Node.nodeType === 1 && Node.classList.contains("shopify-section")) {
					prjx447.InitCustomSections(Node);
				}
			});
		});
	});
	prjx447.ObserverM.observe(document.body, { childList: true, subtree: true });
	prjx447.MenuObserver();
}
{

	prjx447.ProductPageModifiers();
	prjx447.YouTubeObserver();
}




/*

omnisend.push(["identify", {
  email: "trillionpictures@gmail.com",
	status: "subscribed",
	statusDate:new Date().toISOString()
}]);

omnisend.push(["track", "Custom Signup", {
  email: "trillionpictures@gmail.com",
  fields: {
	 custom_discount_interest: "20% Off" // Optional custom property
  }
}]);

curl \
-H 'accept: application/json' \
-H 'content-type: appliction/json' \
-H 'Authorization: Omnisend-API-Key 5cb7716d8653ed5a50b0fb24-J7km9dBYa80XZRqMna92T00JoSMjY9M0sKTMkqR7Vbv4yHgZ7P' \
-H 'Omnisend-Version: 2026-03-15' \
-d '{"eventName": "prjx447-OmniEvent", "systemName": "prjx447-OmniSys", "origin": "api", "contact": { "email": "trillionpictures@gmail.com" }, "properties": { "discount_value": "20%" }}' \
'https://api.omnisend.com/v3/events'

prjx447.Omnisend = function () {
	let FncD = {};
	FncD.Url = "https://api.omnisend.com/v3/events";
	FncD.Headers = { accept: "application/json", "content-type": "application/json", "Authorization": "Omnisend-API-Key 5cb7716d8653ed5a50b0fb24-J7km9dBYa80XZRqMna92T00JoSMjY9M0sKTMkqR7Vbv4yHgZ7P", "Omnisend-Version": "2026-03-15" };
	FncD.PostData = { eventName: "prjx447-OmniEvent", systemName: "prjx447-OmniSys", origin: "api", contact: { email: "trillionpictures@gmail.com" }, properties: { discount_value: "20%" } };
	fetch(FncD.Url, { method: "POST", headers: FncD.Headers, body: JSON.stringify(FncD.PostData) })
		.then(ThisReturn => {
			return ThisReturn.json();
		})
		.then(ThisReturn => {
			console.log(ThisReturn);
		})
		.catch(Err => {
			console.log(Err);
		});

	FncD = {};
	FncD.Url = "https://api.omnisend.com/v3/events";
	FncD.Headers = { accept: "application/json", "content-type": "application/json", "X-API-KEY": "5cb7716d8653ed5a50b0fb24-J7km9dBYa80XZRqMna92T00JoSMjY9M0sKTMkqR7Vbv4yHgZ7P" };
	FncD.PostData = { eventName: "prjx447-OmniEvent", systemName: "prjx447-OmniSys", origin: "api", contact: { email: "trillionpictures@gmail.com" }, properties: { discount_value: "20%" } };
	fetch(FncD.Url, { method: "POST", headers: FncD.Headers, body: JSON.stringify(FncD.PostData) })
		.then(ThisReturn => {
			return ThisReturn.json();
		})
		.then(ThisReturn => {
			console.log(ThisReturn);
		})
		.catch(Err => {
			console.log(Err);
		});
}

ThisFnc=()=>{
	let CreepBox, LetterSpacing, ScaleX, ScaleY;
	CreepBox=parseInt(Math.random()*4);
	LetterSpacing=Math.random()*.1;
	ScaleX=1 + (Math.random()*.01);
	ScaleY=1 + (Math.random()*.01);
	$($(".banner__box .RowText")[CreepBox]).css({transform:`scale(${ScaleX}, ${ScaleY})`});
	setTimeout(()=>{
	 ThisFnc();
	},100)
}
ThisFnc();

*/




